// Generated from trek/message_catalog.json. Do not edit IDs or translations here.
export const MESSAGE_CATALOG = [
    {
        "id": 3007,
        "key": "operation_warning",
        "ru": "Операция выполнена с предупреждением. Проверьте результат.",
        "en": "The operation completed with a warning. Check the result."
    },
    {
        "id": 1000,
        "key": "request_success",
        "ru": "Запрос выполнен.",
        "en": "Request completed."
    },
    {
        "id": 1001,
        "key": "created",
        "ru": "Данные созданы.",
        "en": "Data created."
    },
    {
        "id": 1002,
        "key": "accepted",
        "ru": "Операция принята в обработку.",
        "en": "The operation has been accepted for processing."
    },
    {
        "id": 1400,
        "key": "invalid_request",
        "ru": "Проверьте введённые данные и попробуйте ещё раз.",
        "en": "Check the entered data and try again."
    },
    {
        "id": 1401,
        "key": "authentication_required",
        "ru": "Войдите в аккаунт, чтобы продолжить.",
        "en": "Sign in to continue.",
        "aliases": [
            "Authentication credentials were not provided",
            "not_authenticated"
        ]
    },
    {
        "id": 1403,
        "key": "permission_denied",
        "ru": "У вас нет доступа к этому действию.",
        "en": "You do not have permission to perform this action.",
        "aliases": [
            "No access",
            "Permission denied",
            "You do not have permission to perform this action"
        ]
    },
    {
        "id": 1404,
        "key": "not_found",
        "ru": "Запрашиваемые данные не найдены. Возможно, они были удалены.",
        "en": "The requested data was not found. It may have been deleted.",
        "aliases": [
            "Not found"
        ]
    },
    {
        "id": 1405,
        "key": "method_not_allowed",
        "ru": "Это действие недоступно.",
        "en": "This action is unavailable."
    },
    {
        "id": 1409,
        "key": "conflict",
        "ru": "Не удалось выполнить действие: данные изменились. Обновите страницу.",
        "en": "The action could not be completed because the data has changed. Refresh the page."
    },
    {
        "id": 1410,
        "key": "gone",
        "ru": "Эти данные больше недоступны.",
        "en": "This data is no longer available."
    },
    {
        "id": 1413,
        "key": "file_too_large",
        "ru": "Файл слишком большой. Выберите файл меньшего размера.",
        "en": "The file is too large. Choose a smaller file."
    },
    {
        "id": 1415,
        "key": "unsupported_media_type",
        "ru": "Формат данных не поддерживается. Проверьте выбранный файл.",
        "en": "The data format is not supported. Check the selected file."
    },
    {
        "id": 1429,
        "key": "throttled",
        "ru": "Слишком много запросов. Подождите немного и попробуйте снова.",
        "en": "Too many requests. Wait a moment and try again."
    },
    {
        "id": 1500,
        "key": "internal_error",
        "ru": "Не удалось выполнить действие. Попробуйте позже.",
        "en": "The action could not be completed. Try again later.",
        "aliases": [
            "Internal server error"
        ]
    },
    {
        "id": 1502,
        "key": "bad_gateway",
        "ru": "Внешний сервис временно недоступен. Попробуйте позже.",
        "en": "An external service is temporarily unavailable. Try again later."
    },
    {
        "id": 1503,
        "key": "service_unavailable",
        "ru": "Сервис временно недоступен. Попробуйте позже.",
        "en": "The service is temporarily unavailable. Try again later."
    },
    {
        "id": 1504,
        "key": "gateway_timeout",
        "ru": "Сервис не ответил вовремя. Попробуйте позже.",
        "en": "The service did not respond in time. Try again later."
    },
    {
        "id": 2000,
        "key": "request_timeout",
        "ru": "Сервер не ответил вовремя. Проверьте интернет-соединение и повторите попытку.",
        "en": "The server did not respond in time. Check your internet connection and try again."
    },
    {
        "id": 2001,
        "key": "network_unavailable",
        "ru": "Нет соединения с интернетом",
        "en": "No internet connection",
        "aliases": [
            "Network request failed",
            "Failed to fetch",
            "NetworkError when attempting to fetch resource."
        ]
    },
    {
        "id": 2002,
        "key": "request_cancelled",
        "ru": "Запрос отменён.",
        "en": "The request was cancelled."
    },
    {
        "id": 2003,
        "key": "unsafe_request_url",
        "ru": "Запрос к внешнему адресу заблокирован",
        "en": "The request to an external address was blocked"
    },
    {
        "id": 2004,
        "key": "invalid_response",
        "ru": "Не удалось обработать ответ сервера. Попробуйте ещё раз.",
        "en": "The server response could not be processed. Try again."
    },
    {
        "id": 2100,
        "key": "field_required",
        "ru": "Заполните это поле.",
        "en": "This field is required.",
        "aliases": [
            "This field is required"
        ]
    },
    {
        "id": 2101,
        "key": "field_blank",
        "ru": "Поле не должно быть пустым.",
        "en": "This field may not be blank.",
        "aliases": [
            "This field may not be blank"
        ]
    },
    {
        "id": 2102,
        "key": "field_null",
        "ru": "Укажите значение этого поля.",
        "en": "Provide a value for this field.",
        "aliases": [
            "This field may not be null"
        ]
    },
    {
        "id": 2103,
        "key": "invalid_integer",
        "ru": "Введите целое число.",
        "en": "Enter a valid integer.",
        "aliases": [
            "A valid integer is required"
        ]
    },
    {
        "id": 2104,
        "key": "invalid_number",
        "ru": "Введите число.",
        "en": "Enter a valid number.",
        "aliases": [
            "A valid number is required"
        ]
    },
    {
        "id": 2105,
        "key": "invalid_boolean",
        "ru": "Выберите один из предложенных вариантов.",
        "en": "Select one of the available options.",
        "aliases": [
            "Must be a valid boolean"
        ]
    },
    {
        "id": 2106,
        "key": "invalid_email",
        "ru": "Введите корректный адрес электронной почты.",
        "en": "Enter a valid email address.",
        "aliases": [
            "Enter a valid email address"
        ]
    },
    {
        "id": 2107,
        "key": "invalid_url",
        "ru": "Введите корректную ссылку.",
        "en": "Enter a valid URL.",
        "aliases": [
            "Enter a valid URL"
        ]
    },
    {
        "id": 2200,
        "key": "token_expired",
        "ru": "Срок входа истёк. Войдите в аккаунт ещё раз.",
        "en": "Your session has expired. Sign in again.",
        "aliases": [
            "Token is invalid or expired",
            "Given token not valid for any token type",
            "Invalid token",
            "token_not_valid"
        ]
    },
    {
        "id": 3000,
        "key": "offline_conflict",
        "ru": "Данные на сервере изменились. Проверьте изменения перед синхронизацией.",
        "en": "The server data has changed. Review the changes before synchronizing."
    },
    {
        "id": 3001,
        "key": "offline_invalid",
        "ru": "Проверьте локальные изменения перед синхронизацией.",
        "en": "Check the local changes before synchronizing."
    },
    {
        "id": 3002,
        "key": "offline_replay_mismatch",
        "ru": "Повторный запрос отличается от ранее отправленного. Проверьте операцию.",
        "en": "The repeated request differs from the original request. Check the operation."
    },
    {
        "id": 3003,
        "key": "background_failure",
        "ru": "Фоновая операция завершилась с ошибкой",
        "en": "The background operation failed"
    },
    {
        "id": 3004,
        "key": "background_timeout",
        "ru": "Превышено время ожидания фоновой операции",
        "en": "The background operation timed out"
    },
    {
        "id": 3005,
        "key": "payment_failed",
        "ru": "Не удалось выполнить оплату через RuStore.",
        "en": "The RuStore payment could not be completed."
    },
    {
        "id": 3006,
        "key": "map_failed",
        "ru": "Не удалось загрузить карту.",
        "en": "The map could not be loaded."
    },
    {
        "id": 10000,
        "key": "message_10000",
        "ru": "Дата окончания не может быть раньше даты начала.",
        "en": "The end date cannot be earlier than the start date."
    },
    {
        "id": 10001,
        "key": "message_10001",
        "ru": "Исходная и целевая валюты не должны совпадать.",
        "en": "The source and target currencies must be different."
    },
    {
        "id": 10002,
        "key": "message_10002",
        "ru": "Должно быть > 0.",
        "en": "Must be greater than 0."
    },
    {
        "id": 10003,
        "key": "message_10003",
        "ru": "День не принадлежит выбранному путешествию.",
        "en": "The day does not belong to the selected trip."
    },
    {
        "id": 10004,
        "key": "message_10004",
        "ru": "Не удалось вычислить курс из сумм.",
        "en": "Could not calculate the exchange rate from the amounts."
    },
    {
        "id": 10005,
        "key": "message_10005",
        "ru": "Временный файл изображения путешествия не найден",
        "en": "The temporary trip image file was not found"
    },
    {
        "id": 10006,
        "key": "message_10006",
        "ru": "Временный файл фонового изображения не найден",
        "en": "The temporary background image file was not found"
    },
    {
        "id": 10007,
        "key": "message_10007",
        "ru": "Временный файл мобильного фона не найден",
        "en": "The temporary mobile background file was not found"
    },
    {
        "id": 10008,
        "key": "message_10008",
        "ru": "Не удалось обработать изображение",
        "en": "Could not process the image"
    },
    {
        "id": 10009,
        "key": "message_10009",
        "ru": "Не удалось обработать изображение путешествия",
        "en": "Could not process the trip image"
    },
    {
        "id": 10010,
        "key": "message_10010",
        "ru": "Не удалось обработать фоновое изображение",
        "en": "Could not process the background image"
    },
    {
        "id": 10011,
        "key": "message_10011",
        "ru": "Не удалось обработать мобильный фон",
        "en": "Could not process the mobile background"
    },
    {
        "id": 10012,
        "key": "message_10012",
        "ru": "Временный файл изображения точки #{p0} не найден",
        "en": "The temporary image file for point #{p0} was not found",
        "template": true
    },
    {
        "id": 10013,
        "key": "message_10013",
        "ru": "Не удалось обработать изображение точки #{p0}",
        "en": "Could not process the image for point #{p0}",
        "template": true
    },
    {
        "id": 10014,
        "key": "message_10014",
        "ru": "Количество должно быть больше 0.",
        "en": "Quantity must be greater than 0."
    },
    {
        "id": 10015,
        "key": "message_10015",
        "ru": "Вес должен быть больше 0.",
        "en": "Weight must be greater than 0."
    },
    {
        "id": 10016,
        "key": "message_10016",
        "ru": "Пользователь не является участником этого путешествия.",
        "en": "The user is not a participant in this trip."
    },
    {
        "id": 10017,
        "key": "message_10017",
        "ru": "Название подборки обязательно.",
        "en": "A collection name is required."
    },
    {
        "id": 10018,
        "key": "message_10018",
        "ru": "Не определены финансы проверенного путешествия.",
        "en": "The validated trip has no financial records configured."
    },
    {
        "id": 10019,
        "key": "message_10019",
        "ru": "Нельзя изменить принадлежность записи к путешествию.",
        "en": "The trip associated with this record cannot be changed."
    },
    {
        "id": 10020,
        "key": "message_10020",
        "ru": "Такая комбинация 'план + страна + валюта + тип' уже существует!",
        "en": "This combination of plan, country, currency and type already exists!"
    },
    {
        "id": 10021,
        "key": "message_10021",
        "ru": "Финансы не соответствуют выбранному путешествию.",
        "en": "The financial records do not match the selected trip."
    },
    {
        "id": 10022,
        "key": "message_10022",
        "ru": "Плательщик больше не является участником путешествия. Выберите другого плательщика.",
        "en": "The payer is no longer a trip participant. Select another payer."
    },
    {
        "id": 10023,
        "key": "message_10023",
        "ru": "Должно быть от 2 до 25 точек маршрута",
        "en": "The route must contain 2 to 25 points"
    },
    {
        "id": 10024,
        "key": "message_10024",
        "ru": "points не должен быть пустым",
        "en": "points must not be empty"
    },
    {
        "id": 10025,
        "key": "message_10025",
        "ru": "Можно передать не более 25 точек за раз",
        "en": "You can submit no more than 25 points at a time"
    },
    {
        "id": 10026,
        "key": "message_10026",
        "ru": "Укажите координаты точки на карте.",
        "en": "Select the point coordinates on the map.",
        "public_translation": true,
        "aliases": [
            "coordinates должен быть объектом GeoJSON Point.",
            "Ожидается объект GeoJSON Point.",
            "У точки не указаны координаты (coords)"
        ]
    },
    {
        "id": 10027,
        "key": "message_10027",
        "ru": "Нужно выбрать хотя бы одну вкладку для показа.",
        "en": "Select at least one tab to display."
    },
    {
        "id": 10028,
        "key": "message_10028",
        "ru": "Задача завершена.",
        "en": "The task is complete."
    },
    {
        "id": 10029,
        "key": "message_10029",
        "ru": "Копировать можно только публичное путешествие.",
        "en": "Only public trips can be copied."
    },
    {
        "id": 10030,
        "key": "message_10030",
        "ru": "Выбранный тариф допускает {p0} {p1}, а для копирования требуется {p2}.",
        "en": "The selected plan allows {p0} {p1}, but copying requires {p2}.",
        "template": true
    },
    {
        "id": 10031,
        "key": "message_10031",
        "ru": "Выберите другое личное путешествие для копирования.",
        "en": "Select another personal trip as the copy destination."
    },
    {
        "id": 10032,
        "key": "message_10032",
        "ru": "В выбранном путешествии ещё обрабатываются данные: например, создаётся маршрут или загружаются файлы. После завершения обработки повторите копирование.",
        "en": "The selected trip is still processing data, such as building a route or uploading files. Try copying again after processing is complete."
    },
    {
        "id": 10033,
        "key": "message_10033",
        "ru": "Для полного копирования фотографий точек нужен другой тариф. В выбранном тарифе доступно {p0} фото на точку.",
        "en": "Copying all point photos requires a different plan. The selected plan allows {p0} photos per point.",
        "template": true
    },
    {
        "id": 10034,
        "key": "message_10034",
        "ru": "В выбранном тарифе недостаточно места для всех файлов. Выберите другой тариф.",
        "en": "The selected plan does not have enough room for all files. Select another plan."
    },
    {
        "id": 10035,
        "key": "message_10035",
        "ru": "Автор не открыл разделы для копирования.",
        "en": "The author has not made any sections available for copying."
    },
    {
        "id": 10036,
        "key": "message_10036",
        "ru": "Выберите тариф, в котором достаточно места для полной копии.",
        "en": "Select a plan with enough room for the full copy."
    },
    {
        "id": 10037,
        "key": "message_10037",
        "ru": "Докупите недостающие лимиты для выбранного путешествия и повторите проверку. Лимит фото на одну точку зависит от тарифа.",
        "en": "Purchase the missing limits for the selected trip and check again. The number of photos per point depends on the plan."
    },
    {
        "id": 10038,
        "key": "message_10038",
        "ru": "Не удалось скопировать файл путешествия.",
        "en": "Could not copy the trip file."
    },
    {
        "id": 10039,
        "key": "message_10039",
        "ru": "В выбранном тарифе недостаточно места для всех фотографий. Выберите другой тариф.",
        "en": "The selected plan does not have enough room for all photos. Select another plan."
    },
    {
        "id": 10040,
        "key": "message_10040",
        "ru": "Не удалось скопировать файл из внешнего хранилища.",
        "en": "Could not copy the file from external storage."
    },
    {
        "id": 10041,
        "key": "message_10041",
        "ru": "Один из файлов путешествия недоступен. Копия не создана. Попробуйте позже.",
        "en": "One of the trip files is unavailable. No copy was created. Try again later."
    },
    {
        "id": 10042,
        "key": "message_10042",
        "ru": "Этот запрос уже использован для другого копирования.",
        "en": "This request has already been used for a different copy operation."
    },
    {
        "id": 10043,
        "key": "message_10043",
        "ru": "Не удалось проверить доступность сайта партнёра. Ссылка сформирована, но сайт может временно не открываться.",
        "en": "Could not check the partner website availability. The link was created, but the website may be temporarily unavailable."
    },
    {
        "id": 10044,
        "key": "message_10044",
        "ru": "У вас нет прав на редактирование этого путешествия!",
        "en": "You do not have permission to edit this trip!"
    },
    {
        "id": 10045,
        "key": "message_10045",
        "ru": "Нет доступа к этому путешествию!",
        "en": "You do not have access to this trip!"
    },
    {
        "id": 10046,
        "key": "message_10046",
        "ru": "Автор закрыл доступ к этому разделу путешествия.",
        "en": "The author has restricted access to this trip section."
    },
    {
        "id": 10047,
        "key": "message_10047",
        "ru": "Путешествие сейчас изменяется другим пользователем. Повторите попытку чуть позже.",
        "en": "Another user is currently changing this trip. Try again shortly."
    },
    {
        "id": 10048,
        "key": "message_10048",
        "ru": "Вы временно заблокированы. Повторите через {p0} сек.",
        "en": "You are temporarily blocked. Try again in {p0} seconds.",
        "template": true
    },
    {
        "id": 10049,
        "key": "message_10049",
        "ru": "Доступ разрешён только участникам путешествия.",
        "en": "Access is limited to trip participants."
    },
    {
        "id": 10050,
        "key": "message_10050",
        "ru": "Доступ временно заблокирован. Повторите через {p0} сек.",
        "en": "Access is temporarily blocked. Try again in {p0} seconds.",
        "template": true
    },
    {
        "id": 10051,
        "key": "message_10051",
        "ru": "Путешествие не найдено",
        "en": "Trip not found"
    },
    {
        "id": 10052,
        "key": "message_10052",
        "ru": "Это личное путешествие. Просмотр по публичной ссылке недоступен.",
        "en": "This is a personal trip. Viewing via a public link is unavailable."
    },
    {
        "id": 10053,
        "key": "message_10053",
        "ru": "Редактирование доступно только для публичных путешествий!",
        "en": "Editing is available only for public trips!"
    },
    {
        "id": 10054,
        "key": "message_10054",
        "ru": "У вас нет прав администратора для редактирования публичного путешествия!",
        "en": "You do not have administrator permission to edit a public trip!"
    },
    {
        "id": 10055,
        "key": "message_10055",
        "ru": "Не указан идентификатор путешествия",
        "en": "The trip identifier was not provided"
    },
    {
        "id": 10056,
        "key": "message_10056",
        "ru": "Публичный маршрут был окончательно удалён",
        "en": "The public route was permanently deleted"
    },
    {
        "id": 10057,
        "key": "message_10057",
        "ru": "Координаты должны быть числами.",
        "en": "Coordinates must be numbers."
    },
    {
        "id": 10058,
        "key": "message_10058",
        "ru": "Долгота должна быть от −180 до 180, широта — от −90 до 90.",
        "en": "Longitude must be between -180 and 180, and latitude between -90 and 90."
    },
    {
        "id": 10059,
        "key": "message_10059",
        "ru": "Укажите координаты широты и долготы.",
        "en": "Provide latitude and longitude coordinates."
    },
    {
        "id": 10060,
        "key": "message_10060",
        "ru": "Укажите координаты точки.",
        "en": "Provide the point coordinates."
    },
    {
        "id": 10061,
        "key": "message_10061",
        "ru": "Неподдерживаемый формат даты: {p0}",
        "en": "Unsupported date format: {p0}",
        "template": true
    },
    {
        "id": 10062,
        "key": "message_10062",
        "ru": "Указанная базовая валюта не найдена.",
        "en": "The specified base currency was not found."
    },
    {
        "id": 10063,
        "key": "message_10063",
        "ru": "Нельзя удалить валюту, так как по ней есть ненулевая сумма. Сначала удалите/обнулите расходы в этой валюте.",
        "en": "The currency cannot be deleted because it has a nonzero amount. First delete or reset the expenses in this currency."
    },
    {
        "id": 10064,
        "key": "message_10064",
        "ru": "Неверный формат файла. Пожалуйста, загрузите GPX файл.",
        "en": "Invalid file format. Please upload a GPX file."
    },
    {
        "id": 10065,
        "key": "message_10065",
        "ru": "Ошибка при обработке GPX файла '{p0}'",
        "en": "Error processing GPX file '{p0}'",
        "template": true
    },
    {
        "id": 10066,
        "key": "message_10066",
        "ru": "Ошибка декодирования GPX. Файл должен быть в UTF-8.",
        "en": "GPX decoding error. The file must use UTF-8 encoding."
    },
    {
        "id": 10067,
        "key": "message_10067",
        "ru": "Файл изображения не был передан.",
        "en": "No image file was provided."
    },
    {
        "id": 10068,
        "key": "message_10068",
        "ru": "Не удалось обработать или сохранить изображение.",
        "en": "Could not process or save the image."
    },
    {
        "id": 10069,
        "key": "message_10069",
        "ru": "Ошибка при обработке изображения: {p0}",
        "en": "Error processing the image: {p0}",
        "template": true
    },
    {
        "id": 10070,
        "key": "message_10070",
        "ru": "Неизвестный тип изображения.",
        "en": "Unknown image type."
    },
    {
        "id": 10071,
        "key": "message_10071",
        "ru": "Локальная сессия уже завершена. Откройте облачную версию.",
        "en": "The local session has already ended. Open the cloud version."
    },
    {
        "id": 10072,
        "key": "message_10072",
        "ru": "Для промежуточных пунктов диапазона точки не создаются",
        "en": "Points are not created for intermediate items in a date range"
    },
    {
        "id": 10073,
        "key": "message_10073",
        "ru": "points должен быть непустым списком",
        "en": "points must be a nonempty list"
    },
    {
        "id": 10074,
        "key": "message_10074",
        "ru": "Для пунктов типа 1 и 2 нужно передавать от 2 до 25 точек",
        "en": "Item types 1 and 2 require 2 to 25 points"
    },
    {
        "id": 10075,
        "key": "message_10075",
        "ru": "Укажите корректное положительное целое число.",
        "en": "Enter a valid positive integer."
    },
    {
        "id": 10076,
        "key": "message_10076",
        "ru": "TravelFinance не найден",
        "en": "TravelFinance not found"
    },
    {
        "id": 10077,
        "key": "message_10077",
        "ru": "Финансы для данного путешествия не найдены",
        "en": "Financial records for this trip were not found"
    },
    {
        "id": 10078,
        "key": "message_10078",
        "ru": "Для выбранного тарифа не настроены лимиты.",
        "en": "Limits have not been configured for the selected plan."
    },
    {
        "id": 10079,
        "key": "message_10079",
        "ru": "Некорректный фильтр года",
        "en": "Invalid year filter"
    },
    {
        "id": 10080,
        "key": "message_10080",
        "ru": "Для старого трека не сохранены опорные точки. Добавьте промежуточные точки для нового расчёта или выберите прямой маршрут. Прежний трек сохранён.",
        "en": "The old track has no saved waypoints. Add intermediate points to recalculate it or select a straight route. The previous track was preserved."
    },
    {
        "id": 10081,
        "key": "message_10081",
        "ru": "Для редактирования передайте ровно одну точку",
        "en": "Provide exactly one point for editing"
    },
    {
        "id": 10082,
        "key": "message_10082",
        "ru": "Профиль пользователя не найден",
        "en": "User profile not found",
        "aliases": [
            "User profile was not found"
        ]
    },
    {
        "id": 10083,
        "key": "message_10083",
        "ru": "Существующие фотографии можно сохранять только при редактировании.",
        "en": "Existing photos can only be retained when editing."
    },
    {
        "id": 10084,
        "key": "message_10084",
        "ru": "Фотография не принадлежит этому перемещению.",
        "en": "The photo does not belong to this movement."
    },
    {
        "id": 10085,
        "key": "message_10085",
        "ru": "Не переданы точки",
        "en": "No points were provided"
    },
    {
        "id": 10086,
        "key": "message_10086",
        "ru": "Пустой список точек",
        "en": "The point list is empty"
    },
    {
        "id": 10087,
        "key": "message_10087",
        "ru": "Ошибка при создании точек",
        "en": "Error creating points"
    },
    {
        "id": 10088,
        "key": "message_10088",
        "ru": "Ошибка при получении точек",
        "en": "Error retrieving points"
    },
    {
        "id": 10089,
        "key": "message_10089",
        "ru": "Ошибка при создании перемещения",
        "en": "Error creating the movement"
    },
    {
        "id": 10090,
        "key": "message_10090",
        "ru": "Не удалось пересчитать трек. Прежнее перемещение сохранено.",
        "en": "Could not recalculate the track. The previous movement was preserved."
    },
    {
        "id": 10091,
        "key": "message_10091",
        "ru": "Ошибка при получении передвижений",
        "en": "Error retrieving movements"
    },
    {
        "id": 10092,
        "key": "message_10092",
        "ru": "Ошибка при удалении точки",
        "en": "Error deleting the point"
    },
    {
        "id": 10093,
        "key": "message_10093",
        "ru": "Ошибка при удалении передвижения",
        "en": "Error deleting the movement"
    },
    {
        "id": 10094,
        "key": "message_10094",
        "ru": "Ошибка при получении списка лет",
        "en": "Error retrieving the list of years"
    },
    {
        "id": 10095,
        "key": "message_10095",
        "ru": "Некорректный параметр year. Используйте 'За все время' или год в формате YYYY",
        "en": "Invalid year parameter. Use 'All time' or a year in YYYY format"
    },
    {
        "id": 10096,
        "key": "message_10096",
        "ru": "Локальный режим доступен только автору личного путешествия.",
        "en": "Local mode is available only to the author of a personal trip."
    },
    {
        "id": 10097,
        "key": "message_10097",
        "ru": "Некорректная локальная сессия.",
        "en": "Invalid local session."
    },
    {
        "id": 10098,
        "key": "message_10098",
        "ru": "Подтвердите потерю неотправленных изменений.",
        "en": "Confirm the loss of changes that have not been sent."
    },
    {
        "id": 10099,
        "key": "message_10099",
        "ru": "Сессия не найдена.",
        "en": "Session not found."
    },
    {
        "id": 10100,
        "key": "message_10100",
        "ru": "Обновите список путешествий.",
        "en": "Refresh the trip list."
    },
    {
        "id": 10101,
        "key": "message_10101",
        "ru": "Дождитесь завершения фоновых задач путешествия и повторите скачивание.",
        "en": "Wait for the trip background tasks to finish and try downloading again."
    },
    {
        "id": 10102,
        "key": "message_10102",
        "ru": "Недоступная сессия.",
        "en": "The session is unavailable."
    },
    {
        "id": 10103,
        "key": "message_10103",
        "ru": "Идентификатор уже использован для другого запроса.",
        "en": "The identifier has already been used for another request."
    },
    {
        "id": 10104,
        "key": "message_10104",
        "ru": "Некорректная операция.",
        "en": "Invalid operation."
    },
    {
        "id": 10105,
        "key": "message_10105",
        "ru": "Неизвестный вид операции.",
        "en": "Unknown operation kind."
    },
    {
        "id": 10106,
        "key": "message_10106",
        "ru": "Некорректный идентификатор операции.",
        "en": "Invalid operation identifier."
    },
    {
        "id": 10107,
        "key": "message_10107",
        "ru": "Новый расход должен иметь локальный идентификатор.",
        "en": "A new expense must have a local identifier."
    },
    {
        "id": 10108,
        "key": "message_10108",
        "ru": "Не передана исходная версия расхода.",
        "en": "The original expense version was not provided."
    },
    {
        "id": 10109,
        "key": "message_10109",
        "ru": "Расход изменён или удалён на сервере. Локальные изменения не применены.",
        "en": "The expense was changed or deleted on the server. Local changes were not applied."
    },
    {
        "id": 10110,
        "key": "message_10110",
        "ru": "Не переданы данные расхода.",
        "en": "Expense data was not provided."
    },
    {
        "id": 10111,
        "key": "message_10111",
        "ru": "Укажите положительную сумму, корректный курс и дату.",
        "en": "Provide a positive amount, a valid exchange rate and a date."
    },
    {
        "id": 10112,
        "key": "message_10112",
        "ru": "Ожидается объект с пакетом операций.",
        "en": "An object containing a batch of operations is expected."
    },
    {
        "id": 10113,
        "key": "message_10113",
        "ru": "Пакет должен содержать от 1 до 1000 операций.",
        "en": "The batch must contain 1 to 1000 operations."
    },
    {
        "id": 10114,
        "key": "message_10114",
        "ru": "Повторяющиеся идентификаторы операций.",
        "en": "Duplicate operation identifiers."
    },
    {
        "id": 10115,
        "key": "message_10115",
        "ru": "Неизвестный вид расхода.",
        "en": "Unknown expense kind."
    },
    {
        "id": 10116,
        "key": "message_10116",
        "ru": "Несколько операций для одного расхода.",
        "en": "Multiple operations refer to the same expense."
    },
    {
        "id": 10117,
        "key": "message_10117",
        "ru": "Бюджет путешествия удалён или ещё не настроен.",
        "en": "The trip budget was deleted or has not been configured yet."
    },
    {
        "id": 10118,
        "key": "message_10118",
        "ru": "Базовая валюта или бюджет изменились. Обновите копию бюджета перед отправкой расходов; старые курсы не применены.",
        "en": "The base currency or budget has changed. Refresh the budget copy before sending expenses; the old exchange rates were not applied."
    },
    {
        "id": 10119,
        "key": "message_10119",
        "ru": "Проверьте данные расходов.",
        "en": "Check the expense data."
    },
    {
        "id": 10120,
        "key": "message_10120",
        "ru": "Идентификатор операции уже использован.",
        "en": "The operation identifier has already been used."
    },
    {
        "id": 10121,
        "key": "message_10121",
        "ru": "Некорректная исходная сумма или курс.",
        "en": "Invalid original amount or exchange rate."
    },
    {
        "id": 10122,
        "key": "message_10122",
        "ru": "Офлайн-расходы может отправлять только автор путешествия.",
        "en": "Only the trip author can submit offline expenses."
    },
    {
        "id": 10123,
        "key": "message_10123",
        "ru": "Не удалось получить обновлённые пункты.",
        "en": "Could not retrieve the updated items."
    },
    {
        "id": 10124,
        "key": "message_10124",
        "ru": "Некорректный пакет пунктов.",
        "en": "Invalid item batch."
    },
    {
        "id": 10125,
        "key": "message_10125",
        "ru": "Отправляйте от 1 до 100 черновиков за один раз.",
        "en": "Send 1 to 100 drafts at a time."
    },
    {
        "id": 10126,
        "key": "message_10126",
        "ru": "План изменился на сервере. Черновики сохранены на телефоне; обновите исходные данные перед повторной отправкой.",
        "en": "The plan has changed on the server. Drafts remain on your phone; refresh the original data before sending them again."
    },
    {
        "id": 10127,
        "key": "message_10127",
        "ru": "Офлайн-пункты может изменять только автор путешествия.",
        "en": "Only the trip author can change offline items."
    },
    {
        "id": 10128,
        "key": "message_10128",
        "ru": "Некорректный черновик.",
        "en": "Invalid draft."
    },
    {
        "id": 10129,
        "key": "message_10129",
        "ru": "Повторяющийся пункт в пакете.",
        "en": "Duplicate item in the batch."
    },
    {
        "id": 10130,
        "key": "message_10130",
        "ru": "Некорректные поля идентификации пункта.",
        "en": "Invalid item identification fields."
    },
    {
        "id": 10131,
        "key": "message_10131",
        "ru": "Не удалось сохранить все параметры пункта.",
        "en": "Could not save all item parameters."
    },
    {
        "id": 10132,
        "key": "message_10132",
        "ru": "Пункт удалён или не принадлежит путешествию.",
        "en": "The item was deleted or does not belong to this trip."
    },
    {
        "id": 10133,
        "key": "message_10133",
        "ru": "Не указана локальная сессия.",
        "en": "No local session was specified."
    },
    {
        "id": 10134,
        "key": "message_10134",
        "ru": "Пункт не принадлежит путешествию.",
        "en": "The item does not belong to this trip."
    },
    {
        "id": 10135,
        "key": "message_10135",
        "ru": "Точки может синхронизировать только автор.",
        "en": "Only the author can synchronize points."
    },
    {
        "id": 10136,
        "key": "message_10136",
        "ru": "Некорректная операция карты.",
        "en": "Invalid map operation."
    },
    {
        "id": 10137,
        "key": "message_10137",
        "ru": "Точка не принадлежит пункту путешествия.",
        "en": "The point does not belong to the trip item."
    },
    {
        "id": 10138,
        "key": "message_10138",
        "ru": "Файл слишком большой.",
        "en": "The file is too large."
    },
    {
        "id": 10139,
        "key": "message_10139",
        "ru": "Нужно от 1 до 25 точек.",
        "en": "Between 1 and 25 points are required."
    },
    {
        "id": 10140,
        "key": "message_10140",
        "ru": "Некорректные поля точки.",
        "en": "Invalid point fields."
    },
    {
        "id": 10141,
        "key": "message_10141",
        "ru": "Неизвестная операция карты.",
        "en": "Unknown map operation."
    },
    {
        "id": 10142,
        "key": "message_10142",
        "ru": "Сохранение временно недоступно. Повторите синхронизацию.",
        "en": "Saving is temporarily unavailable. Try synchronizing again."
    },
    {
        "id": 10143,
        "key": "message_10143",
        "ru": "Завершение трека раньше начала.",
        "en": "The track ends before it starts."
    },
    {
        "id": 10144,
        "key": "message_10144",
        "ru": "Неизвестный тип трека.",
        "en": "Unknown track type."
    },
    {
        "id": 10145,
        "key": "message_10145",
        "ru": "Перемещение уже добавлено.",
        "en": "The movement has already been added."
    },
    {
        "id": 10146,
        "key": "message_10146",
        "ru": "Не передан GPX.",
        "en": "No GPX was provided."
    },
    {
        "id": 10147,
        "key": "message_10147",
        "ru": "Неверный статус вкладки",
        "en": "Invalid tab status"
    },
    {
        "id": 10148,
        "key": "message_10148",
        "ru": "Ошибка в перечне публичных путешествий.",
        "en": "Error in the public trip list."
    },
    {
        "id": 10149,
        "key": "message_10149",
        "ru": "Ошибка получения деталей путешествия.",
        "en": "Error retrieving trip details."
    },
    {
        "id": 10150,
        "key": "message_10150",
        "ru": "Публичное путешествие не найдено.",
        "en": "Public trip not found."
    },
    {
        "id": 10151,
        "key": "message_10151",
        "ru": "План путешествия не найден или нет доступа",
        "en": "The trip plan was not found or access is denied"
    },
    {
        "id": 10152,
        "key": "message_10152",
        "ru": "Ошибка получения плана",
        "en": "Error retrieving the plan"
    },
    {
        "id": 10153,
        "key": "message_10153",
        "ru": "Доступ только для администратора.",
        "en": "Access is limited to administrators."
    },
    {
        "id": 10154,
        "key": "message_10154",
        "ru": "Ссылка неполная. Откройте её заново из приложения.",
        "en": "The link is incomplete. Open it again from the application.",
        "aliases": [
            "token is required"
        ]
    },
    {
        "id": 10155,
        "key": "message_10155",
        "ru": "Некорректная ссылка сервиса.",
        "en": "Invalid service link."
    },
    {
        "id": 10156,
        "key": "message_10156",
        "ru": "Выберите сервис бронирования.",
        "en": "Select a booking service.",
        "aliases": [
            "service_code is required"
        ]
    },
    {
        "id": 10157,
        "key": "message_10157",
        "ru": "Некорректные параметры поиска. Повторите выбор.",
        "en": "Invalid search parameters. Select them again.",
        "aliases": [
            "context must be an object"
        ]
    },
    {
        "id": 10158,
        "key": "message_10158",
        "ru": "Выберите путешествие.",
        "en": "Select a trip.",
        "aliases": [
            "travel_plan_id is required"
        ]
    },
    {
        "id": 10159,
        "key": "message_10159",
        "ru": "Ссылка устарела. Откройте бронирование ещё раз.",
        "en": "The link has expired. Open the booking again."
    },
    {
        "id": 10160,
        "key": "message_10160",
        "ru": "Некорректная ссылка бронирования.",
        "en": "Invalid booking link."
    },
    {
        "id": 10161,
        "key": "message_10161",
        "ru": "Не удалось определить пункт путешествия. Повторите выбор.",
        "en": "Could not identify the trip item. Select it again.",
        "aliases": [
            "item_id must be an integer"
        ]
    },
    {
        "id": 10162,
        "key": "message_10162",
        "ru": "Полный PDF доступен организатору и участникам путешествия.",
        "en": "The full PDF is available to the trip organizer and participants."
    },
    {
        "id": 10163,
        "key": "message_10163",
        "ru": "Очередь формирования PDF временно недоступна.",
        "en": "The PDF generation queue is temporarily unavailable."
    },
    {
        "id": 10164,
        "key": "message_10164",
        "ru": "Нет доступа к полному PDF путешествия.",
        "en": "Access to the full trip PDF is denied."
    },
    {
        "id": 10165,
        "key": "message_10165",
        "ru": "PDF ещё не сформирован.",
        "en": "The PDF has not been generated yet."
    },
    {
        "id": 10166,
        "key": "message_10166",
        "ru": "Файл PDF не найден. Запустите формирование повторно.",
        "en": "The PDF file was not found. Generate it again."
    },
    {
        "id": 10167,
        "key": "message_10167",
        "ru": "Не удалось поставить формирование PDF в очередь.",
        "en": "Could not queue PDF generation."
    },
    {
        "id": 10168,
        "key": "message_10168",
        "ru": "Массовая отправка приглашений друзьям выполнена.",
        "en": "Bulk invitations to friends have been sent."
    },
    {
        "id": 10169,
        "key": "message_10169",
        "ru": "Начать путешествие может только организатор.",
        "en": "Only the organizer can start the trip."
    },
    {
        "id": 10170,
        "key": "message_10170",
        "ru": "Изменять видимость путешествия могут только организатор и участники.",
        "en": "Only the organizer and participants can change trip visibility."
    },
    {
        "id": 10171,
        "key": "message_10171",
        "ru": "Для путешествий общего каталога видимость в профиле недоступна.",
        "en": "Profile visibility is unavailable for trips in the public catalogue."
    },
    {
        "id": 10172,
        "key": "message_10172",
        "ru": "Неизвестный уровень видимости путешествия.",
        "en": "Unknown trip visibility level."
    },
    {
        "id": 10173,
        "key": "message_10173",
        "ru": "Настройки вашего профиля не позволяют выбрать этот уровень видимости.",
        "en": "Your profile settings do not allow this visibility level."
    },
    {
        "id": 10174,
        "key": "message_10174",
        "ru": "Нужно выбрать хотя бы один раздел путешествия.",
        "en": "Select at least one trip section."
    },
    {
        "id": 10175,
        "key": "message_10175",
        "ru": "Приглашение отправлено",
        "en": "Invitation sent"
    },
    {
        "id": 10176,
        "key": "message_10176",
        "ru": "У пользователя нет друзей для приглашения.",
        "en": "The user has no friends to invite."
    },
    {
        "id": 10177,
        "key": "message_10177",
        "ru": "Некого приглашать: все друзья уже участники или имеют активные заявки по этому путешествию.",
        "en": "There is nobody to invite: all friends are already participants or have active requests for this trip."
    },
    {
        "id": 10178,
        "key": "message_10178",
        "ru": "Приглашение отменено.",
        "en": "Invitation cancelled."
    },
    {
        "id": 10179,
        "key": "message_10179",
        "ru": "Ошибка в перечне ваших путешествий.",
        "en": "Error in your trip list."
    },
    {
        "id": 10180,
        "key": "message_10180",
        "ru": "Начать путешествие можно только в первый день поездки.",
        "en": "You can start a trip only on its first day."
    },
    {
        "id": 10181,
        "key": "message_10181",
        "ru": "Не удалось загрузить лимиты путешествия. Попробуйте позже.",
        "en": "Could not load the trip limits. Try again later."
    },
    {
        "id": 10182,
        "key": "message_10182",
        "ru": "Поле tabs должно быть объектом с настройками разделов.",
        "en": "The tabs field must be an object containing section settings."
    },
    {
        "id": 10183,
        "key": "message_10183",
        "ru": "Нельзя пригласить самого себя.",
        "en": "You cannot invite yourself."
    },
    {
        "id": 10184,
        "key": "message_10184",
        "ru": "Ошибка обработки параметров.",
        "en": "Error processing parameters."
    },
    {
        "id": 10185,
        "key": "message_10185",
        "ru": "Этого пользователя сейчас нельзя пригласить.",
        "en": "This user cannot be invited at the moment.",
        "aliases": [
            "User is unavailable for invitation"
        ]
    },
    {
        "id": 10186,
        "key": "message_10186",
        "ru": "Пользователь запретил приглашения в путешествия.",
        "en": "The user has disabled trip invitations."
    },
    {
        "id": 10187,
        "key": "message_10187",
        "ru": "Получатель или путешествие не найдены.",
        "en": "The recipient or trip was not found."
    },
    {
        "id": 10188,
        "key": "message_10188",
        "ru": "Пользователь уже является участником этого путешествия.",
        "en": "The user is already a participant in this trip."
    },
    {
        "id": 10189,
        "key": "message_10189",
        "ru": "Есть активный запрос между вами по этому путешествию.",
        "en": "There is an active request between you for this trip."
    },
    {
        "id": 10190,
        "key": "message_10190",
        "ru": "Ошибка проверки ограничений.",
        "en": "Error checking restrictions."
    },
    {
        "id": 10191,
        "key": "message_10191",
        "ru": "Не удалось отправить приглашение.",
        "en": "Could not send the invitation."
    },
    {
        "id": 10192,
        "key": "message_10192",
        "ru": "Ошибка получения данных пользователя/путешествия.",
        "en": "Error retrieving user or trip data."
    },
    {
        "id": 10193,
        "key": "message_10193",
        "ru": "Не удалось найти данные пользователя или путешествия.",
        "en": "Could not find the user or trip data."
    },
    {
        "id": 10194,
        "key": "message_10194",
        "ru": "Ошибка при отмене приглашения.",
        "en": "Error cancelling the invitation."
    },
    {
        "id": 10195,
        "key": "message_10195",
        "ru": "Ошибка получения путешествия.",
        "en": "Error retrieving the trip."
    },
    {
        "id": 10196,
        "key": "message_10196",
        "ru": "Участник в этом путешествии не найден.",
        "en": "The participant was not found in this trip."
    },
    {
        "id": 10197,
        "key": "message_10197",
        "ru": "Ошибка при изменении прав участника.",
        "en": "Error changing participant permissions."
    },
    {
        "id": 10198,
        "key": "message_10198",
        "ru": "Ошибка при удалении участника.",
        "en": "Error removing the participant."
    },
    {
        "id": 10199,
        "key": "message_10199",
        "ru": "Не удалось получить список ваших путешествий.",
        "en": "Could not retrieve your trip list."
    },
    {
        "id": 10200,
        "key": "message_10200",
        "ru": "Ошибка сериализации ваших путешествий.",
        "en": "Error serializing your trips."
    },
    {
        "id": 10201,
        "key": "message_10201",
        "ru": "Нет права приглашать участников.",
        "en": "You do not have permission to invite participants."
    },
    {
        "id": 10202,
        "key": "message_10202",
        "ru": "Пользователь уже является участником.",
        "en": "The user is already a participant."
    },
    {
        "id": 10203,
        "key": "message_10203",
        "ru": "Приглашение уже существует.",
        "en": "The invitation already exists."
    },
    {
        "id": 10204,
        "key": "message_10204",
        "ru": "Заявка не найдена.",
        "en": "Request not found."
    },
    {
        "id": 10205,
        "key": "message_10205",
        "ru": "Невозможно отменить заявку (уточните параметры).",
        "en": "The request cannot be cancelled. Check the parameters."
    },
    {
        "id": 10207,
        "key": "message_10207",
        "ru": "Нельзя изменять права у организатора.",
        "en": "The organizer's permissions cannot be changed."
    },
    {
        "id": 10208,
        "key": "message_10208",
        "ru": "Назначать участника редактором можно только в тарифе «Профи».",
        "en": "A participant can be assigned as an editor only on the Pro plan."
    },
    {
        "id": 10209,
        "key": "message_10209",
        "ru": "Нельзя удалить организатора путешествия.",
        "en": "The trip organizer cannot be removed."
    },
    {
        "id": 10210,
        "key": "message_10210",
        "ru": "Не удалось создать/обновить заявку.",
        "en": "Could not create or update the request."
    },
    {
        "id": 10211,
        "key": "message_10211",
        "ru": "Вы не являетесь инициатором этой заявки.",
        "en": "You did not initiate this request."
    },
    {
        "id": 10212,
        "key": "message_10212",
        "ru": "Нельзя отменить заявку со статусом '{p0}'.",
        "en": "A request with status '{p0}' cannot be cancelled.",
        "template": true
    },
    {
        "id": 10213,
        "key": "message_10213",
        "ru": "Недостаточно прав.",
        "en": "Insufficient permissions."
    },
    {
        "id": 10214,
        "key": "message_10214",
        "ru": "Сначала создайте личное путешествие, затем выберите его для копирования публичного маршрута.",
        "en": "First create a personal trip, then select it as the destination for copying the public route."
    },
    {
        "id": 10215,
        "key": "message_10215",
        "ru": "Путешествие создано успешно",
        "en": "Trip created successfully"
    },
    {
        "id": 10216,
        "key": "message_10216",
        "ru": "Путешествие удалено",
        "en": "Trip deleted"
    },
    {
        "id": 10217,
        "key": "message_10217",
        "ru": "Путешествие обновлено успешно",
        "en": "Trip updated successfully"
    },
    {
        "id": 10218,
        "key": "message_10218",
        "ru": "Внутренняя ошибка сервера",
        "en": "Internal server error"
    },
    {
        "id": 10219,
        "key": "message_10219",
        "ru": "Ошибка при удалении плана путешествия",
        "en": "Error deleting the trip plan"
    },
    {
        "id": 10220,
        "key": "message_10220",
        "ru": "Не найден активный тип тарифа для создания путешествия.",
        "en": "No active plan type was found for creating a trip."
    },
    {
        "id": 10221,
        "key": "message_10221",
        "ru": "Ошибка обновления стран",
        "en": "Error updating countries"
    },
    {
        "id": 10222,
        "key": "message_10222",
        "ru": "Наименования должны быть объектом.",
        "en": "Names must be an object."
    },
    {
        "id": 10223,
        "key": "message_10223",
        "ru": "Количество описаний не совпадает с количеством изображений",
        "en": "The number of descriptions does not match the number of images"
    },
    {
        "id": 10224,
        "key": "message_10224",
        "ru": "Лимиты по картинкам закончились",
        "en": "The image limit has been reached"
    },
    {
        "id": 10225,
        "key": "message_10225",
        "ru": "Ручное наименование должно содержать от 1 до 200 символов.",
        "en": "A manually entered name must contain 1 to 200 characters."
    },
    {
        "id": 10226,
        "key": "message_10226",
        "ru": "Ошибка получения описания",
        "en": "Error retrieving the description"
    },
    {
        "id": 10227,
        "key": "message_10227",
        "ru": "Ошибка при сохранении изображений",
        "en": "Error saving images"
    },
    {
        "id": 10228,
        "key": "message_10228",
        "ru": "Не удалось удалить медиа-элемент.",
        "en": "Could not delete the media item."
    },
    {
        "id": 10229,
        "key": "message_10229",
        "ru": "У вас нет прав для редактирования этого путешествия.",
        "en": "You do not have permission to edit this trip."
    },
    {
        "id": 10230,
        "key": "message_10230",
        "ru": "Неверный mode. Используйте 'hand' или 'gpt'.",
        "en": "Invalid mode. Use 'hand' or 'gpt'."
    },
    {
        "id": 10231,
        "key": "message_10231",
        "ru": "Поле \"title\" должно быть строкой.",
        "en": "The \"title\" field must be a string."
    },
    {
        "id": 10232,
        "key": "message_10232",
        "ru": "Поле \"text\" должно быть строкой.",
        "en": "The \"text\" field must be a string."
    },
    {
        "id": 10233,
        "key": "message_10233",
        "ru": "Поле \"text\" обязательно.",
        "en": "The \"text\" field is required."
    },
    {
        "id": 10234,
        "key": "message_10234",
        "ru": "Заголовок слишком длинный. Максимум {p0} символов.",
        "en": "The title is too long. Maximum {p0} characters.",
        "template": true
    },
    {
        "id": 10235,
        "key": "message_10235",
        "ru": "Описание слишком длинное. Максимум {p0} символов.",
        "en": "The description is too long. Maximum {p0} characters.",
        "template": true
    },
    {
        "id": 10236,
        "key": "message_10236",
        "ru": "Не удалось сохранить описание.",
        "en": "Could not save the description."
    },
    {
        "id": 10237,
        "key": "message_10237",
        "ru": "Некорректные параметры наименования.",
        "en": "Invalid name parameters."
    },
    {
        "id": 10238,
        "key": "message_10238",
        "ru": "Выбранная страна не входит в страны путешествия.",
        "en": "The selected country is not included in this trip."
    },
    {
        "id": 10239,
        "key": "message_10239",
        "ru": "Укажите параметры пункта путешествия.",
        "en": "Enter the trip item details.",
        "public_translation": true,
        "aliases": [
            "Поле params обязательно."
        ]
    },
    {
        "id": 10240,
        "key": "message_10240",
        "ru": "Не удалось прочитать параметры пункта. Заполните форму ещё раз.",
        "en": "Unable to read the item details. Fill out the form again.",
        "public_translation": true,
        "aliases": [
            "Некорректный JSON в поле params.",
            "Некорректный формат поля params.",
            "Поле params должно быть массивом.",
            "params must be a list"
        ]
    },
    {
        "id": 10241,
        "key": "message_10241",
        "ru": "Для указанного типа пункта нет параметров.",
        "en": "There are no parameters for the specified item type."
    },
    {
        "id": 10242,
        "key": "message_10242",
        "ru": "Не удалось определить даты пункта (нет ни одной даты).",
        "en": "Could not determine the item dates: no date was provided."
    },
    {
        "id": 10243,
        "key": "message_10243",
        "ru": "Дата окончания пункта раньше даты начала пункта.",
        "en": "The item end date is earlier than its start date."
    },
    {
        "id": 10244,
        "key": "message_10244",
        "ru": "Дата начала пункта раньше даты начала путешествия ({p0}).",
        "en": "The item start date is earlier than the trip start date ({p0}).",
        "template": true
    },
    {
        "id": 10245,
        "key": "message_10245",
        "ru": "Дата окончания пункта позже даты окончания путешествия ({p0}).",
        "en": "The item end date is later than the trip end date ({p0}).",
        "template": true
    },
    {
        "id": 10246,
        "key": "message_10246",
        "ru": "Состав пунктов изменился. Обновите наименования перед сохранением.",
        "en": "The item composition has changed. Refresh the names before saving."
    },
    {
        "id": 10247,
        "key": "message_10247",
        "ru": "Не удалось определить диапазон дат пункта.",
        "en": "Could not determine the item date range."
    },
    {
        "id": 10248,
        "key": "message_10248",
        "ru": "Дата начала пункта раньше даты начала путешествия.",
        "en": "The item start date is earlier than the trip start date."
    },
    {
        "id": 10249,
        "key": "message_10249",
        "ru": "Дата окончания пункта позже даты окончания путешествия.",
        "en": "The item end date is later than the trip end date."
    },
    {
        "id": 10250,
        "key": "message_10250",
        "ru": "Не удалось сохранить пункт путешествия.",
        "en": "Could not save the trip item."
    },
    {
        "id": 10252,
        "key": "message_10252",
        "ru": "День путешествия не найден.",
        "en": "Trip day not found."
    },
    {
        "id": 10253,
        "key": "message_10253",
        "ru": "Поле title обязательно.",
        "en": "The title field is required."
    },
    {
        "id": 10254,
        "key": "message_10254",
        "ru": "Длина title не должна превышать 120 символов.",
        "en": "The title must not exceed 120 characters."
    },
    {
        "id": 10255,
        "key": "message_10255",
        "ru": "Не удалось обновить заголовок дня путешествия.",
        "en": "Could not update the trip day title."
    },
    {
        "id": 10256,
        "key": "message_10256",
        "ru": "Не удалось редактировать пункт путешествия.",
        "en": "Could not edit the trip item."
    },
    {
        "id": 10257,
        "key": "message_10257",
        "ru": "Не удалось редактировать пункт путешествия (нет params).",
        "en": "Could not edit the trip item: params are missing."
    },
    {
        "id": 10258,
        "key": "message_10258",
        "ru": "Некорректный формат params.",
        "en": "Invalid params format."
    },
    {
        "id": 10259,
        "key": "message_10259",
        "ru": "Пустые params.",
        "en": "params are empty."
    },
    {
        "id": 10260,
        "key": "message_10260",
        "ru": "Часть параметров не удалось сохранить",
        "en": "Some parameters could not be saved"
    },
    {
        "id": 10261,
        "key": "message_10261",
        "ru": "Список ID пуст.",
        "en": "The ID list is empty."
    },
    {
        "id": 10262,
        "key": "message_10262",
        "ru": "Не удалось удалить пункты путешествия.",
        "en": "Could not delete the trip items."
    },
    {
        "id": 10263,
        "key": "message_10263",
        "ru": "Не удалось удалить группу пунктов путешествия.",
        "en": "Could not delete the trip item group."
    },
    {
        "id": 10264,
        "key": "message_10264",
        "ru": "Некорректные данные для планирования путешествия.",
        "en": "Invalid trip planning data."
    },
    {
        "id": 10265,
        "key": "message_10265",
        "ru": "Некорректный формат поля params.",
        "en": "Invalid format of the params field."
    },
    {
        "id": 10266,
        "key": "message_10266",
        "ru": "На эти дату и время уже есть пункты. Проверьте, что всё корректно.",
        "en": "Items already exist at this date and time. Check that everything is correct."
    },
    {
        "id": 10267,
        "key": "message_10267",
        "ru": "На эти даты уже есть пункты. Проверьте, что всё корректно.",
        "en": "Items already exist on these dates. Check that everything is correct."
    },
    {
        "id": 10268,
        "key": "message_10268",
        "ru": "Наименование должно быть строкой длиной до 200 символов.",
        "en": "The name must be a string of up to 200 characters."
    },
    {
        "id": 10269,
        "key": "message_10269",
        "ru": "Передайте \"id\" (число) или \"ids\" (список чисел).",
        "en": "Provide \"id\" as a number or \"ids\" as a list of numbers."
    },
    {
        "id": 10270,
        "key": "message_10270",
        "ru": "ID пунктов должны быть целыми числами.",
        "en": "Item IDs must be integers."
    },
    {
        "id": 10271,
        "key": "message_10271",
        "ru": "Часть пунктов не найдена.",
        "en": "Some items were not found."
    },
    {
        "id": 10272,
        "key": "message_10272",
        "ru": "Пункты отсутствуют",
        "en": "There are no items"
    },
    {
        "id": 10273,
        "key": "message_10273",
        "ru": "Группа пунктов не найдена.",
        "en": "Item group not found."
    },
    {
        "id": 10274,
        "key": "message_10274",
        "ru": "Не удалось удалить файл медиа.",
        "en": "Could not delete the media file."
    },
    {
        "id": 10275,
        "key": "message_10275",
        "ru": "Неожиданная ошибка при удалении файла медиа.",
        "en": "Unexpected error deleting the media file."
    },
    {
        "id": 10276,
        "key": "message_10276",
        "ru": "Некорректная дата в параметре {p0}.",
        "en": "Invalid date in parameter {p0}.",
        "template": true
    },
    {
        "id": 10277,
        "key": "message_10277",
        "ru": "Дата в параметре {p0} раньше даты начала путешествия ({p1}).",
        "en": "The date in parameter {p0} is earlier than the trip start date ({p1}).",
        "template": true
    },
    {
        "id": 10278,
        "key": "message_10278",
        "ru": "Дата в параметре {p0} позже даты окончания путешествия ({p1}).",
        "en": "The date in parameter {p0} is later than the trip end date ({p1}).",
        "template": true
    },
    {
        "id": 10279,
        "key": "message_10279",
        "ru": "Пункт не найден.",
        "en": "Item not found."
    },
    {
        "id": 10280,
        "key": "message_10280",
        "ru": "Указанный день путешествия не найден.",
        "en": "The specified trip day was not found."
    },
    {
        "id": 10281,
        "key": "message_10281",
        "ru": "Для нового типа пункта не пришли параметры.",
        "en": "Parameters for the new item type were not provided."
    },
    {
        "id": 10282,
        "key": "message_10282",
        "ru": "Дата параметра раньше даты начала путешествия.",
        "en": "The parameter date is earlier than the trip start date."
    },
    {
        "id": 10283,
        "key": "message_10283",
        "ru": "Дата параметра позже даты окончания путешествия.",
        "en": "The parameter date is later than the trip end date."
    },
    {
        "id": 10284,
        "key": "message_10284",
        "ru": "Некорректная дата: {p0}",
        "en": "Invalid date: {p0}",
        "template": true
    },
    {
        "id": 10285,
        "key": "message_10285",
        "ru": "Некорректное время: {p0}",
        "en": "Invalid time: {p0}",
        "template": true
    },
    {
        "id": 10286,
        "key": "message_10286",
        "ru": "Некорректное время в параметре {p0}.",
        "en": "Invalid time in parameter {p0}.",
        "template": true
    },
    {
        "id": 10287,
        "key": "message_10287",
        "ru": "Ошибка получения подборок",
        "en": "Error retrieving collections"
    },
    {
        "id": 10288,
        "key": "message_10288",
        "ru": "У пользователя нет профиля.",
        "en": "The user has no profile."
    },
    {
        "id": 10289,
        "key": "message_10289",
        "ru": "Ошибка при сохранении снаряжения",
        "en": "Error saving equipment"
    },
    {
        "id": 10290,
        "key": "message_10290",
        "ru": "Ошибка при удалении снаряжения",
        "en": "Error deleting equipment"
    },
    {
        "id": 10291,
        "key": "message_10291",
        "ru": "Ошибка при создании подборки",
        "en": "Error creating the collection"
    },
    {
        "id": 10292,
        "key": "message_10292",
        "ru": "Ошибка при применении подборки",
        "en": "Error applying the collection"
    },
    {
        "id": 10293,
        "key": "message_10293",
        "ru": "Снаряжение не найдено.",
        "en": "Equipment not found."
    },
    {
        "id": 10294,
        "key": "message_10294",
        "ru": "Ошибка при получении данных по файлам.",
        "en": "Error retrieving file data."
    },
    {
        "id": 10295,
        "key": "message_10295",
        "ru": "Ошибка при скачивании файла.",
        "en": "Error downloading the file."
    },
    {
        "id": 10296,
        "key": "message_10296",
        "ru": "Файл(ы) не переданы.",
        "en": "No files were provided."
    },
    {
        "id": 10297,
        "key": "message_10297",
        "ru": "Общий размер файлов не должен превышать 30 МБ.",
        "en": "The total file size must not exceed 30 MB."
    },
    {
        "id": 10298,
        "key": "message_10298",
        "ru": "Недопустимый тип файла.",
        "en": "Unsupported file type."
    },
    {
        "id": 10299,
        "key": "message_10299",
        "ru": "Ошибка при загрузке файлов.",
        "en": "Error uploading files."
    },
    {
        "id": 10300,
        "key": "message_10300",
        "ru": "Укажите название.",
        "en": "Provide a name.",
        "aliases": [
            "Field `name` is required"
        ]
    },
    {
        "id": 10301,
        "key": "message_10301",
        "ru": "Укажите название файла.",
        "en": "Provide a file name.",
        "aliases": [
            "File name cannot be empty"
        ]
    },
    {
        "id": 10302,
        "key": "message_10302",
        "ru": "Название файла должно содержать не более 200 символов.",
        "en": "The file name must contain no more than 200 characters.",
        "aliases": [
            "File name is too long (max 200 characters)"
        ]
    },
    {
        "id": 10303,
        "key": "message_10303",
        "ru": "Не удалось изменить название файла. Попробуйте позже.",
        "en": "Could not change the file name. Try again later.",
        "aliases": [
            "Error updating file name"
        ]
    },
    {
        "id": 10304,
        "key": "message_10304",
        "ru": "Ошибка при удалении файла.",
        "en": "Error deleting the file."
    },
    {
        "id": 10305,
        "key": "message_10305",
        "ru": "Размер фотографии не должен превышать 25 МБ.",
        "en": "Photo size must not exceed 25 MB."
    },
    {
        "id": 10306,
        "key": "message_10306",
        "ru": "Размер документа не должен превышать 10 МБ.",
        "en": "Document size must not exceed 10 MB."
    },
    {
        "id": 10307,
        "key": "message_10307",
        "ru": "Выбранный пункт путешествия не найден или уже удалён.",
        "en": "The selected trip item was not found or has already been deleted."
    },
    {
        "id": 10308,
        "key": "message_10308",
        "ru": "Не выбраны записи для изменения.",
        "en": "No records were selected for editing.",
        "aliases": [
            "updates must be a non-empty list"
        ]
    },
    {
        "id": 10309,
        "key": "message_10309",
        "ru": "За один раз можно изменить не более 200 записей.",
        "en": "You can update no more than 200 records at a time.",
        "aliases": [
            "updates cannot contain more than 200 items"
        ]
    },
    {
        "id": 10310,
        "key": "message_10310",
        "ru": "Проверьте данные изменяемых записей.",
        "en": "Check the data of the records being updated.",
        "aliases": [
            "Invalid updates"
        ]
    },
    {
        "id": 10311,
        "key": "message_10311",
        "ru": "Ошибка при получении финансов путешествия: {p0}",
        "en": "Error retrieving trip finances: {p0}",
        "template": true
    },
    {
        "id": 10312,
        "key": "message_10312",
        "ru": "Ошибка при получении данных для графиков",
        "en": "Error retrieving chart data"
    },
    {
        "id": 10313,
        "key": "message_10313",
        "ru": "Выберите пункт путешествия.",
        "en": "Select a trip item.",
        "public_translation": true,
        "aliases": [
            "Не указан item_id",
            "Необходимо передать корректный item_id."
        ]
    },
    {
        "id": 10314,
        "key": "message_10314",
        "ru": "Проверьте данные изменяемой записи.",
        "en": "Check the data of the record being updated.",
        "aliases": [
            "update must be an object"
        ]
    },
    {
        "id": 10315,
        "key": "message_10315",
        "ru": "Выберите бронирование и пункт путешествия.",
        "en": "Select a booking and a trip item."
    },
    {
        "id": 10316,
        "key": "message_10316",
        "ru": "Одно бронирование указано несколько раз.",
        "en": "The same booking was specified more than once.",
        "aliases": [
            "duplicate booking_id"
        ]
    },
    {
        "id": 10317,
        "key": "message_10317",
        "ru": "Один пункт путешествия указан несколько раз.",
        "en": "The same trip item was specified more than once.",
        "aliases": [
            "duplicate item_travel_id"
        ]
    },
    {
        "id": 10318,
        "key": "message_10318",
        "ru": "Не удалось обновить расходы по бронированиям. Проверьте выбранные записи.",
        "en": "Could not update expenses from bookings. Check the selected records.",
        "aliases": [
            "Travelpayouts expense updates validation failed"
        ]
    },
    {
        "id": 10319,
        "key": "message_10319",
        "ru": "Поля с валютами по странам обязательны!",
        "en": "Currency fields for each country are required!"
    },
    {
        "id": 10320,
        "key": "message_10320",
        "ru": "Ошибка при сохранении финансов по странам",
        "en": "Error saving finances by country"
    },
    {
        "id": 10321,
        "key": "message_10321",
        "ru": "Предыдущий пересчёт валют ещё выполняется. Повторите сохранение после его завершения.",
        "en": "The previous currency recalculation is still running. Save again after it finishes."
    },
    {
        "id": 10322,
        "key": "message_10322",
        "ru": "Ошибка при редактировании финансов по странам",
        "en": "Error editing finances by country"
    },
    {
        "id": 10323,
        "key": "message_10323",
        "ru": "Ошибка при сохранении фактического расхода",
        "en": "Error saving the actual expense"
    },
    {
        "id": 10324,
        "key": "message_10324",
        "ru": "Ошибка при редактировании расхода",
        "en": "Error editing the expense"
    },
    {
        "id": 10325,
        "key": "message_10325",
        "ru": "Ошибка при удалении расхода",
        "en": "Error deleting the expense"
    },
    {
        "id": 10326,
        "key": "message_10326",
        "ru": "Ошибка при сохранении планируемого расхода",
        "en": "Error saving the planned expense"
    },
    {
        "id": 10327,
        "key": "message_10327",
        "ru": "Планируемый расход или финансовый раздел путешествия не найден.",
        "en": "The planned expense or the trip finance section was not found."
    },
    {
        "id": 10328,
        "key": "message_10328",
        "ru": "Не удалось удалить расход. Попробуйте позже.",
        "en": "Could not delete the expense. Try again later."
    },
    {
        "id": 10329,
        "key": "message_10329",
        "ru": "Расход удалён, но итоги финансов пока не пересчитаны. Повторно удалять расход не нужно.",
        "en": "The expense was deleted, but financial totals have not been recalculated yet. Do not delete the expense again."
    },
    {
        "id": 10330,
        "key": "message_10330",
        "ru": "Ошибка при редактировании обмена валют",
        "en": "Error editing the currency exchange"
    },
    {
        "id": 10331,
        "key": "message_10331",
        "ru": "Ошибка при удалении обмена валют",
        "en": "Error deleting the currency exchange"
    },
    {
        "id": 10332,
        "key": "message_10332",
        "ru": "Выберите корректный пункт путешествия.",
        "en": "Select a valid trip item."
    },
    {
        "id": 10333,
        "key": "message_10333",
        "ru": "Выберите корректные бронирование и пункт путешествия.",
        "en": "Select a valid booking and trip item."
    },
    {
        "id": 10334,
        "key": "message_10334",
        "ru": "Бронирование не найдено.",
        "en": "Booking not found.",
        "aliases": [
            "booking_not_found"
        ]
    },
    {
        "id": 10335,
        "key": "message_10335",
        "ru": "Бронирование относится к другому пункту путешествия.",
        "en": "The booking belongs to another trip item.",
        "aliases": [
            "booking_item_mismatch"
        ]
    },
    {
        "id": 10336,
        "key": "message_10336",
        "ru": "Пункт путешествия не найден.",
        "en": "Trip item not found.",
        "aliases": [
            "item_not_found"
        ]
    },
    {
        "id": 10337,
        "key": "message_10337",
        "ru": "Очередь фоновых задач временно недоступна.",
        "en": "The background task queue is temporarily unavailable."
    },
    {
        "id": 10338,
        "key": "message_10338",
        "ru": "Валюты сохранены, но не удалось запустить пересчёт сумм.",
        "en": "Currencies were saved, but the amounts could not be scheduled for recalculation."
    },
    {
        "id": 10339,
        "key": "message_10339",
        "ru": "Эта операция уже сохранена с другими данными. Обновите бюджет перед редактированием.",
        "en": "This operation has already been saved with different data. Refresh the budget before editing."
    },
    {
        "id": 10340,
        "key": "message_10340",
        "ru": "Для формирования GPX-трека необходимо передать минимум две точки.",
        "en": "At least two points are required to generate a GPX track."
    },
    {
        "id": 10341,
        "key": "message_10341",
        "ru": "За один раз можно выгрузить не более {p0} точек.",
        "en": "You can export no more than {p0} points at a time.",
        "template": true
    },
    {
        "id": 10342,
        "key": "message_10342",
        "ru": "Сохранённый трек содержит точку без координат.",
        "en": "The saved track contains a point without coordinates."
    },
    {
        "id": 10343,
        "key": "message_10343",
        "ru": "Сохранённый трек содержит некорректные координаты.",
        "en": "The saved track contains invalid coordinates."
    },
    {
        "id": 10344,
        "key": "message_10344",
        "ru": "Сохранённый трек содержит координаты вне допустимого диапазона.",
        "en": "The saved track contains coordinates outside the allowed range."
    },
    {
        "id": 10345,
        "key": "message_10345",
        "ru": "В сохранённом треке недостаточно координат для выгрузки GPX.",
        "en": "The saved track does not contain enough coordinates for GPX export."
    },
    {
        "id": 10346,
        "key": "message_10346",
        "ru": "Сохранённый трек содержит более {p0} точек.",
        "en": "The saved track contains more than {p0} points.",
        "template": true
    },
    {
        "id": 10347,
        "key": "message_10347",
        "ru": "Сохранённые фотографии не принадлежат заменяемым точкам.",
        "en": "The saved photos do not belong to the points being replaced."
    },
    {
        "id": 10348,
        "key": "message_10348",
        "ru": "Фоновая задача не найдена.",
        "en": "Background task not found."
    },
    {
        "id": 10349,
        "key": "message_10349",
        "ru": "Выберите пункт путешествия и укажите, выполнен ли он.",
        "en": "Select a trip item and specify whether it is completed.",
        "aliases": [
            "item_travel_id and selected are required"
        ]
    },
    {
        "id": 10350,
        "key": "message_10350",
        "ru": "Выбранный пункт не относится к этому путешествию.",
        "en": "The selected item does not belong to this trip.",
        "aliases": [
            "Item does not belong to this travel plan",
            "item_id не принадлежит путешествию.",
            "item_id does not belong to this travel plan"
        ],
        "public_translation": true
    },
    {
        "id": 10351,
        "key": "message_10351",
        "ru": "Публичное путешествие нельзя включить на личную карту.",
        "en": "A public trip cannot be added to a personal map."
    },
    {
        "id": 10352,
        "key": "message_10352",
        "ru": "Нет данных для обновления точки.",
        "en": "No data was provided to update the point."
    },
    {
        "id": 10353,
        "key": "message_10353",
        "ru": "coordinates.type должен быть 'Point'.",
        "en": "coordinates.type must be 'Point'."
    },
    {
        "id": 10354,
        "key": "message_10354",
        "ru": "coordinates.coordinates должен быть массивом [lon, lat].",
        "en": "coordinates.coordinates must be a [lon, lat] array."
    },
    {
        "id": 10355,
        "key": "message_10355",
        "ru": "Измените маршрут целиком в редакторе перемещения.",
        "en": "Edit the entire route in the movement editor."
    },
    {
        "id": 10356,
        "key": "message_10356",
        "ru": "Не удалось пересчитать трек ({p0}). Прежнее перемещение сохранено.",
        "en": "Could not recalculate the track ({p0}). The previous movement was preserved.",
        "template": true
    },
    {
        "id": 10357,
        "key": "message_10357",
        "ru": "Пункт не принадлежит указанному путешествию.",
        "en": "The item does not belong to the specified trip."
    },
    {
        "id": 10358,
        "key": "message_10358",
        "ru": "Одна или несколько точек не принадлежат указанному пункту путешествия.",
        "en": "One or more points do not belong to the specified trip item."
    },
    {
        "id": 10359,
        "key": "message_10359",
        "ru": "Переданные точки относятся к разным сохранённым трекам.",
        "en": "The submitted points belong to different saved tracks."
    },
    {
        "id": 10360,
        "key": "message_10360",
        "ru": "Файлы не найдены",
        "en": "Files not found"
    },
    {
        "id": 10361,
        "key": "message_10361",
        "ru": "Длины массивов не совпадают",
        "en": "The array lengths do not match"
    },
    {
        "id": 10362,
        "key": "message_10362",
        "ru": "Недостаточно лимита GPX-треков для загрузки выбранных файлов.",
        "en": "The GPX track limit is insufficient to upload the selected files."
    },
    {
        "id": 10363,
        "key": "message_10363",
        "ru": "Точка не принадлежит путешествию",
        "en": "The point does not belong to this trip"
    },
    {
        "id": 10364,
        "key": "message_10364",
        "ru": "Передайте image или images[], но не оба поля одновременно.",
        "en": "Provide image or images[], but not both fields at the same time."
    },
    {
        "id": 10365,
        "key": "message_10365",
        "ru": "В этом тарифе можно сохранить не более {p0} фотографий точки.",
        "en": "This plan allows no more than {p0} photos per point.",
        "template": true
    },
    {
        "id": 10366,
        "key": "message_10366",
        "ru": "Некорректный формат даты. Используйте YYYY-MM-DD.",
        "en": "Invalid date format. Use YYYY-MM-DD."
    },
    {
        "id": 10367,
        "key": "message_10367",
        "ru": "Некорректный формат времени. Используйте HH:MM[:SS].",
        "en": "Invalid time format. Use HH:MM[:SS]."
    },
    {
        "id": 10368,
        "key": "message_10368",
        "ru": "Укажите, отмечен ли пункт как выполненный.",
        "en": "Specify whether the item is marked as completed.",
        "aliases": [
            "selected must be a boolean"
        ]
    },
    {
        "id": 10369,
        "key": "message_10369",
        "ru": "Сохранённый трек не принадлежит указанному пункту.",
        "en": "The saved track does not belong to the specified item."
    },
    {
        "id": 10370,
        "key": "message_10370",
        "ru": "Для указанного пункта сохранённый трек не найден.",
        "en": "No saved track was found for the specified item."
    },
    {
        "id": 10371,
        "key": "message_10371",
        "ru": "У пункта несколько треков; передайте точки, связанные с нужным треком.",
        "en": "The item has multiple tracks; provide points associated with the required track."
    },
    {
        "id": 10372,
        "key": "message_10372",
        "ru": "Перемещение уже добавлено. Измените существующее перемещение.",
        "en": "A movement has already been added. Edit the existing movement."
    },
    {
        "id": 10373,
        "key": "message_10373",
        "ru": "Для каждой точки можно сохранить до {p0} фотографий без повторов.",
        "en": "You can save up to {p0} unique photos for each point.",
        "template": true
    },
    {
        "id": 10374,
        "key": "message_10374",
        "ru": "Сохранённые фотографии можно передавать только при замене точек.",
        "en": "Saved photos can only be submitted when replacing points."
    },
    {
        "id": 10375,
        "key": "message_10375",
        "ru": "Не удалось создать точки",
        "en": "Could not create points"
    },
    {
        "id": 10376,
        "key": "message_10376",
        "ru": "Элемент #{p0}: неверный формат {p1}, ожидается YYYY-MM-DD",
        "en": "Item #{p0}: invalid {p1} format; YYYY-MM-DD is expected",
        "template": true
    },
    {
        "id": 10377,
        "key": "message_10377",
        "ru": "GPX слишком большой.",
        "en": "The GPX file is too large."
    },
    {
        "id": 10378,
        "key": "message_10378",
        "ru": "Не удалось обработать GPX",
        "en": "Could not process the GPX"
    },
    {
        "id": 10379,
        "key": "message_10379",
        "ru": "Ошибка удаления точки",
        "en": "Error deleting the point"
    },
    {
        "id": 10380,
        "key": "message_10380",
        "ru": "Не удалось обработать изображения.",
        "en": "Could not process the images."
    },
    {
        "id": 10381,
        "key": "message_10381",
        "ru": "Для каждого файла укажите индекс точки.",
        "en": "Specify a point index for each file."
    },
    {
        "id": 10382,
        "key": "message_10382",
        "ru": "Элемент #{p0}: файл не передан",
        "en": "Item #{p0}: no file was provided",
        "template": true
    },
    {
        "id": 10383,
        "key": "message_10383",
        "ru": "В этом пункте уже есть перемещение.",
        "en": "This item already has a movement."
    },
    {
        "id": 10385,
        "key": "message_10385",
        "ru": "Индекс фотографии выходит за пределы списка точек.",
        "en": "The photo index is outside the point list bounds."
    },
    {
        "id": 10386,
        "key": "message_10386",
        "ru": "Некорректный индекс точки для фотографии.",
        "en": "Invalid point index for the photo."
    },
    {
        "id": 10387,
        "key": "message_10387",
        "ru": "TravelPlan не найден",
        "en": "TravelPlan not found"
    },
    {
        "id": 10388,
        "key": "message_10388",
        "ru": "Ошибка при получении статистики путешествия: {p0}",
        "en": "Error retrieving trip statistics: {p0}",
        "template": true
    },
    {
        "id": 10389,
        "key": "message_10389",
        "ru": "Выберите личное путешествие и повторите запрос на копирование.",
        "en": "Select a personal trip and repeat the copy request."
    },
    {
        "id": 10390,
        "key": "message_10390",
        "ru": "Изменять ссылку приглашения может только автор путешествия.",
        "en": "Only the trip author can change the invitation link.",
        "aliases": [
            "Only the author can manage the share link"
        ]
    },
    {
        "id": 10391,
        "key": "message_10391",
        "ru": "Путешествие не найдено или уже удалено.",
        "en": "The trip was not found or has already been deleted.",
        "aliases": [
            "Travel plan was not found",
            "Travel plan not found"
        ]
    },
    {
        "id": 10392,
        "key": "message_10392",
        "ru": "Ссылка приглашения не найдена или больше не действует.",
        "en": "The invitation link was not found or is no longer valid.",
        "aliases": [
            "Travel share link was not found"
        ]
    },
    {
        "id": 10393,
        "key": "message_10393",
        "ru": "Некорректное значение флага.",
        "en": "Invalid flag value."
    },
    {
        "id": 10394,
        "key": "message_10394",
        "ru": "Доступ разрешен только администратору.",
        "en": "Access is limited to administrators."
    },
    {
        "id": 10395,
        "key": "message_10395",
        "ru": "Пользователь не найден.",
        "en": "User not found."
    },
    {
        "id": 10396,
        "key": "message_10396",
        "ru": "Нельзя заблокировать текущего пользователя.",
        "en": "The current user cannot be blocked."
    },
    {
        "id": 10397,
        "key": "message_10397",
        "ru": "Ошибка изменения статуса блокировки пользователя.",
        "en": "Error changing the user's blocked status."
    },
    {
        "id": 10398,
        "key": "message_10398",
        "ru": "Нельзя удалить текущего пользователя.",
        "en": "The current user cannot be deleted."
    },
    {
        "id": 10399,
        "key": "message_10399",
        "ru": "Удалять можно только заблокированных пользователей.",
        "en": "Only blocked users can be deleted."
    },
    {
        "id": 10400,
        "key": "message_10400",
        "ru": "Пользователь не удален: есть защищенные связанные данные.",
        "en": "The user was not deleted because protected related data exists."
    },
    {
        "id": 10401,
        "key": "message_10401",
        "ru": "Ошибка удаления пользователя.",
        "en": "Error deleting the user."
    },
    {
        "id": 10402,
        "key": "message_10402",
        "ru": "Некорректный параметр year",
        "en": "Invalid year parameter"
    },
    {
        "id": 10404,
        "key": "message_10404",
        "ru": "Статистика профиля недоступна.",
        "en": "Profile statistics are unavailable."
    },
    {
        "id": 10405,
        "key": "message_10405",
        "ru": "Ошибка при получении пользовательской статистики",
        "en": "Error retrieving user statistics"
    },
    {
        "id": 10406,
        "key": "message_10406",
        "ru": "Укажите корректную почту",
        "en": "Enter a valid email address"
    },
    {
        "id": 10407,
        "key": "message_10407",
        "ru": "Укажите пароль",
        "en": "Enter a password"
    },
    {
        "id": 10408,
        "key": "message_10408",
        "ru": "FriendRequest нельзя принять: статус не pending",
        "en": "FriendRequest cannot be accepted: its status is not pending"
    },
    {
        "id": 10409,
        "key": "message_10409",
        "ru": "FriendRequest нельзя архивировать: статус не accepted",
        "en": "FriendRequest cannot be archived: its status is not accepted"
    },
    {
        "id": 10410,
        "key": "message_10410",
        "ru": "FriendRequest нельзя отменить: статус не pending",
        "en": "FriendRequest cannot be cancelled: its status is not pending"
    },
    {
        "id": 10411,
        "key": "message_10411",
        "ru": "Автор работает с путешествием локально. Принять приглашение можно после синхронизации.",
        "en": "The author is working on the trip locally. The invitation can be accepted after synchronization."
    },
    {
        "id": 10412,
        "key": "message_10412",
        "ru": "Приглашение больше недоступно.",
        "en": "The invitation is no longer available."
    },
    {
        "id": 10413,
        "key": "message_10413",
        "ru": "Приглашение предназначено другому получателю.",
        "en": "The invitation is intended for another recipient."
    },
    {
        "id": 10414,
        "key": "message_10414",
        "ru": "Получатель недоступен.",
        "en": "The recipient is unavailable."
    },
    {
        "id": 10415,
        "key": "message_10415",
        "ru": "Отправитель больше не может приглашать участников.",
        "en": "The sender can no longer invite participants."
    },
    {
        "id": 10416,
        "key": "message_10416",
        "ru": "TravelRequest нельзя отменить: статус не sent/received/accepted",
        "en": "TravelRequest cannot be cancelled: its status is not sent, received or accepted"
    },
    {
        "id": 10417,
        "key": "message_10417",
        "ru": "TravelRequest нельзя отклонить: статус не sent/received",
        "en": "TravelRequest cannot be declined: its status is not sent or received"
    },
    {
        "id": 10418,
        "key": "message_10418",
        "ru": "Для просмотра профиля требуется авторизация.",
        "en": "Sign in to view this profile."
    },
    {
        "id": 10419,
        "key": "message_10419",
        "ru": "Нет доступа к этому профилю.",
        "en": "Access to this profile is denied."
    },
    {
        "id": 10420,
        "key": "message_10420",
        "ru": "Пользователь с таким Email уже зарегистрирован!",
        "en": "A user with this email address is already registered!"
    },
    {
        "id": 10421,
        "key": "message_10421",
        "ru": "username занят",
        "en": "username is already taken"
    },
    {
        "id": 10422,
        "key": "message_10422",
        "ru": "Пароли не совпадают!",
        "en": "The passwords do not match!"
    },
    {
        "id": 10423,
        "key": "message_10423",
        "ru": "Выберите только один режим доступа к профилю.",
        "en": "Select only one profile access mode."
    },
    {
        "id": 10424,
        "key": "message_10424",
        "ru": "Выберите один режим доступа к профилю.",
        "en": "Select a profile access mode."
    },
    {
        "id": 10425,
        "key": "message_10425",
        "ru": "Укажите новый email.",
        "en": "Enter a new email address."
    },
    {
        "id": 10426,
        "key": "message_10426",
        "ru": "Пользователь с таким email уже зарегистрирован.",
        "en": "A user with this email address is already registered."
    },
    {
        "id": 10427,
        "key": "message_10427",
        "ru": "Сначала укажите и подтвердите email, затем можно будет установить пароль.",
        "en": "First provide and verify an email address, then you can set a password."
    },
    {
        "id": 10428,
        "key": "message_10428",
        "ru": "Пароли не совпадают.",
        "en": "The passwords do not match."
    },
    {
        "id": 10429,
        "key": "message_10429",
        "ru": "Неизвестный тип ссылки.",
        "en": "Unknown link type."
    },
    {
        "id": 10430,
        "key": "message_10430",
        "ru": "URL не может быть пустым.",
        "en": "The URL cannot be empty."
    },
    {
        "id": 10431,
        "key": "message_10431",
        "ru": "Ссылка должна использовать HTTPS.",
        "en": "The link must use HTTPS."
    },
    {
        "id": 10432,
        "key": "message_10432",
        "ru": "Укажите ссылку на сервис {p0}.",
        "en": "Provide a link to the {p0} service.",
        "template": true
    },
    {
        "id": 10433,
        "key": "message_10433",
        "ru": "Имя пользователя не может быть пустым.",
        "en": "The username cannot be empty."
    },
    {
        "id": 10434,
        "key": "message_10434",
        "ru": "Имя пользователя уже занято!",
        "en": "This username is already taken!"
    },
    {
        "id": 10435,
        "key": "message_10435",
        "ru": "Email не может быть пустым.",
        "en": "The email address cannot be empty."
    },
    {
        "id": 10436,
        "key": "message_10436",
        "ru": "Пользователь с таким email уже существует.",
        "en": "A user with this email address already exists."
    },
    {
        "id": 10437,
        "key": "message_10437",
        "ru": "Описание слишком длинное.",
        "en": "The description is too long."
    },
    {
        "id": 10438,
        "key": "message_10438",
        "ru": "Email уже зарегистрирован",
        "en": "Email is already registered"
    },
    {
        "id": 10439,
        "key": "message_10439",
        "ru": "Введите текущий пароль.",
        "en": "Enter your current password."
    },
    {
        "id": 10440,
        "key": "message_10440",
        "ru": "Текущий пароль указан неверно.",
        "en": "The current password is incorrect."
    },
    {
        "id": 10441,
        "key": "message_10441",
        "ru": "Некорректный URL.",
        "en": "Invalid URL."
    },
    {
        "id": 10442,
        "key": "message_10442",
        "ru": "У ссылки отсутствует kind",
        "en": "The link is missing kind"
    },
    {
        "id": 10443,
        "key": "message_10443",
        "ru": "У ссылки отсутствует url",
        "en": "The link is missing url"
    },
    {
        "id": 10444,
        "key": "message_10444",
        "ru": "Повторяющиеся ссылки (kind+url) в запросе.",
        "en": "Duplicate links (kind+url) in the request."
    },
    {
        "id": 10445,
        "key": "message_10445",
        "ru": "Ссылка id={p0} не найдена у этого профиля.",
        "en": "Link id={p0} was not found in this profile.",
        "template": true
    },
    {
        "id": 10446,
        "key": "message_10446",
        "ru": "Обмен недоступен до погашения бонусов за отменённые бронирования. Следующие бонусные начисления пойдут на погашение.",
        "en": "Exchange is unavailable until bonuses for cancelled bookings are repaid. Future bonus awards will be used to repay them."
    },
    {
        "id": 10447,
        "key": "message_10447",
        "ru": "Для обмена нужно накопить {p0} неиспользованных бонусных базовых путешествий за приглашения и бронирования.",
        "en": "To exchange bonuses, accumulate {p0} unused bonus basic trips from invitations and bookings.",
        "template": true
    },
    {
        "id": 10448,
        "key": "message_10448",
        "ru": "Заполните обязательные поля.",
        "en": "Fill in the required fields."
    },
    {
        "id": 10449,
        "key": "message_10449",
        "ru": "username обязателен",
        "en": "username is required"
    },
    {
        "id": 10450,
        "key": "message_10450",
        "ru": "username содержит запрещённое слово",
        "en": "username contains a prohibited word"
    },
    {
        "id": 10451,
        "key": "message_10451",
        "ru": "Пароль должен содержать не менее {p0} символов.",
        "en": "The password must contain at least {p0} characters.",
        "template": true
    },
    {
        "id": 10452,
        "key": "message_10452",
        "ru": "Пароль должен содержать хотя бы одну цифру.",
        "en": "The password must contain at least one digit."
    },
    {
        "id": 10453,
        "key": "message_10453",
        "ru": "Имя пользователя может содержать только строчные буквы, цифры и символы подчеркивания.",
        "en": "The username may contain only lowercase letters, digits and underscores."
    },
    {
        "id": 10454,
        "key": "message_10454",
        "ru": "Неверный формат. Разрешены: a–z, 0–9, _ и .",
        "en": "Invalid format. Allowed characters: a-z, 0-9, _ and ."
    },
    {
        "id": 10455,
        "key": "message_10455",
        "ru": "Аккаунт заблокирован и будет безвозвратно удалён через 30 дней. В течение этого срока его можно восстановить через поддержку.",
        "en": "The account is blocked and will be permanently deleted in 30 days. During this period, support can restore it."
    },
    {
        "id": 10456,
        "key": "message_10456",
        "ru": "Укажите дату в формате ГГГГ-ММ-ДД.",
        "en": "Enter a date in YYYY-MM-DD format."
    },
    {
        "id": 10457,
        "key": "message_10457",
        "ru": "Аккаунт неактивен. Обратитесь в поддержку.",
        "en": "The account is inactive. Contact support.",
        "aliases": [
            "Account is inactive"
        ]
    },
    {
        "id": 10458,
        "key": "message_10458",
        "ru": "Не переданы события для сохранения.",
        "en": "No events were provided to save.",
        "aliases": [
            "events must be a non-empty list"
        ]
    },
    {
        "id": 10459,
        "key": "message_10459",
        "ru": "За один раз можно отправить не более {p0} событий.",
        "en": "You can send no more than {p0} events at a time.",
        "template": true
    },
    {
        "id": 10460,
        "key": "message_10460",
        "ru": "Это действие доступно только администратору.",
        "en": "This action is available only to administrators.",
        "aliases": [
            "Administrator access is required",
            "Admin permissions required"
        ]
    },
    {
        "id": 10461,
        "key": "message_10461",
        "ru": "Дата начала не может быть позже даты окончания.",
        "en": "The start date cannot be later than the end date.",
        "aliases": [
            "date_from must not be later than date_to"
        ]
    },
    {
        "id": 10462,
        "key": "message_10462",
        "ru": "Не удалось определить пользователя. Обновите страницу.",
        "en": "Could not identify the user. Refresh the page.",
        "aliases": [
            "Invalid user_id"
        ]
    },
    {
        "id": 10463,
        "key": "message_10463",
        "ru": "Мы отправили  повторное письмо с подтверждением.",
        "en": "We have sent another confirmation email."
    },
    {
        "id": 10464,
        "key": "message_10464",
        "ru": "Если адрес электронной почты зарегистрирован, мы отправим инструкции по восстановлению пароля.",
        "en": "If the email address is registered, we will send password reset instructions."
    },
    {
        "id": 10465,
        "key": "message_10465",
        "ru": "Не удалось применить пригласительную ссылку. Попробуйте позже.",
        "en": "Could not apply the invitation link. Try again later."
    },
    {
        "id": 10466,
        "key": "message_10466",
        "ru": "Вход выполнен.",
        "en": "Signed in."
    },
    {
        "id": 10467,
        "key": "message_10467",
        "ru": "Email обновлён. Подтвердите новый адрес по письму.",
        "en": "Email updated. Verify the new address using the email we sent."
    },
    {
        "id": 10468,
        "key": "message_10468",
        "ru": "Пароль обновлён.",
        "en": "Password updated."
    },
    {
        "id": 10469,
        "key": "message_10469",
        "ru": "Выход выполнен успешно",
        "en": "Signed out successfully"
    },
    {
        "id": 10470,
        "key": "message_10470",
        "ru": "Аккаунт создан. Проверьте почту для подтверждения.",
        "en": "Account created. Check your email to verify it."
    },
    {
        "id": 10471,
        "key": "message_10471",
        "ru": "Email успешно подтверждён",
        "en": "Email verified successfully"
    },
    {
        "id": 10472,
        "key": "message_10472",
        "ru": "Email обязателен",
        "en": "Email is required"
    },
    {
        "id": 10473,
        "key": "message_10473",
        "ru": "Пароль успешно изменен. Войдите в систему с новым паролем.",
        "en": "Password changed successfully. Sign in with the new password."
    },
    {
        "id": 10474,
        "key": "message_10474",
        "ru": "Пользователь уже авторизован.",
        "en": "The user is already signed in."
    },
    {
        "id": 10475,
        "key": "message_10475",
        "ru": "Укажите email и пароль.",
        "en": "Enter your email address and password."
    },
    {
        "id": 10476,
        "key": "message_10476",
        "ru": "Подтвердите email, чтобы войти.",
        "en": "Verify your email address to sign in."
    },
    {
        "id": 10477,
        "key": "message_10477",
        "ru": "Неверный адрес электронной почты или пароль.",
        "en": "Incorrect email address or password."
    },
    {
        "id": 10478,
        "key": "message_10478",
        "ru": "Не удалось выполнить выход",
        "en": "Could not sign out"
    },
    {
        "id": 10479,
        "key": "message_10479",
        "ru": "Некорректная ссылка подтверждения",
        "en": "Invalid confirmation link"
    },
    {
        "id": 10480,
        "key": "message_10480",
        "ru": "Email уже подтверждён",
        "en": "Email is already verified"
    },
    {
        "id": 10481,
        "key": "message_10481",
        "ru": "Подождите минуту и попробуйте снова.",
        "en": "Wait a minute and try again."
    },
    {
        "id": 10482,
        "key": "message_10482",
        "ru": "Некорректный email",
        "en": "Invalid email address"
    },
    {
        "id": 10483,
        "key": "message_10483",
        "ru": "Все поля обязательны",
        "en": "All fields are required"
    },
    {
        "id": 10485,
        "key": "message_10485",
        "ru": "Недействительный или просроченный токен",
        "en": "Invalid or expired token"
    },
    {
        "id": 10486,
        "key": "message_10486",
        "ru": "Слишком много попыток. Попробуйте позже.",
        "en": "Too many attempts. Try again later."
    },
    {
        "id": 10487,
        "key": "message_10487",
        "ru": "Некорректный номер страницы или количество записей.",
        "en": "Invalid page number or page size.",
        "aliases": [
            "page and page_size must be integers",
            "Invalid pagination"
        ]
    },
    {
        "id": 10488,
        "key": "message_10488",
        "ru": "Срок действия ссылки истёк. Запросите письмо повторно.",
        "en": "The link has expired. Request another email."
    },
    {
        "id": 10489,
        "key": "message_10489",
        "ru": "Не удалось подтвердить email. Попробуйте ещё раз.",
        "en": "Could not verify your email address. Try again."
    },
    {
        "id": 10490,
        "key": "message_10490",
        "ru": "Недействительная или устаревшая ссылка",
        "en": "Invalid or expired link"
    },
    {
        "id": 10491,
        "key": "message_10491",
        "ru": "Разрешена только схема https для URL аватара",
        "en": "Only HTTPS is allowed for the avatar URL"
    },
    {
        "id": 10492,
        "key": "message_10492",
        "ru": "Хост аватара не разрешён: {p0}",
        "en": "The avatar host is not allowed: {p0}",
        "template": true
    },
    {
        "id": 10493,
        "key": "message_10493",
        "ru": "Неожиданный Content-Type: {p0}",
        "en": "Unexpected Content-Type: {p0}",
        "template": true
    },
    {
        "id": 10494,
        "key": "message_10494",
        "ru": "Аватар слишком большой",
        "en": "The avatar is too large"
    },
    {
        "id": 10495,
        "key": "message_10495",
        "ru": "Некорректный размер изображения",
        "en": "Invalid image size"
    },
    {
        "id": 10496,
        "key": "message_10496",
        "ru": "Размеры изображения слишком большие",
        "en": "The image dimensions are too large"
    },
    {
        "id": 10497,
        "key": "message_10497",
        "ru": "Количество пикселей изображения слишком большое",
        "en": "The image contains too many pixels"
    },
    {
        "id": 10498,
        "key": "message_10498",
        "ru": "Некорректные данные изображения",
        "en": "Invalid image data"
    },
    {
        "id": 10499,
        "key": "message_10499",
        "ru": "Залогинено через VK ID.",
        "en": "Signed in with VK ID."
    },
    {
        "id": 10500,
        "key": "message_10500",
        "ru": "Размер аватара превышает лимит",
        "en": "Avatar size exceeds the limit"
    },
    {
        "id": 10501,
        "key": "message_10501",
        "ru": "Не удалось подтвердить вход через VK. Начните вход заново.",
        "en": "Could not verify the VK sign-in. Start signing in again.",
        "aliases": [
            "Некорректный state",
            "Не переданы state/code_verifier",
            "Некорректная длина code_verifier"
        ]
    },
    {
        "id": 10502,
        "key": "message_10502",
        "ru": "Запрос на вход уже создан. Начните вход через VK заново.",
        "en": "A sign-in request already exists. Start signing in with VK again.",
        "aliases": [
            "state уже существует"
        ]
    },
    {
        "id": 10503,
        "key": "message_10503",
        "ru": "Не удалось завершить вход через VK. Начните вход заново.",
        "en": "Could not complete the VK sign-in. Start signing in again.",
        "aliases": [
            "Не передан ticket",
            "Некорректный ticket"
        ]
    },
    {
        "id": 10504,
        "key": "message_10504",
        "ru": "Время ожидания входа истекло. Начните вход через VK заново.",
        "en": "The sign-in waiting period has expired. Start signing in with VK again.",
        "aliases": [
            "Срок действия ticket истёк"
        ]
    },
    {
        "id": 10505,
        "key": "message_10505",
        "ru": "Не удалось определить запрос на обмен. Обновите страницу и повторите попытку.",
        "en": "Could not identify the exchange request. Refresh the page and try again."
    },
    {
        "id": 10506,
        "key": "message_10506",
        "ru": "Некорректное значение логического флага.",
        "en": "Invalid boolean flag value."
    },
    {
        "id": 10507,
        "key": "message_10507",
        "ru": "Поле text обязательно.",
        "en": "The text field is required."
    },
    {
        "id": 10508,
        "key": "message_10508",
        "ru": "Некорректная аудитория сообщения.",
        "en": "Invalid message audience."
    },
    {
        "id": 10509,
        "key": "message_10509",
        "ru": "Получатели не найдены.",
        "en": "Recipients not found."
    },
    {
        "id": 10510,
        "key": "message_10510",
        "ru": "Не удалось отправить системное сообщение.",
        "en": "Could not send the system message."
    },
    {
        "id": 10511,
        "key": "message_10511",
        "ru": "Часть пользователей не найдена.",
        "en": "Some users were not found."
    },
    {
        "id": 10512,
        "key": "message_10512",
        "ru": "Аккаунт неактивен.",
        "en": "The account is inactive."
    },
    {
        "id": 10513,
        "key": "message_10513",
        "ru": "Этот тип приложения не поддерживается.",
        "en": "This application type is not supported.",
        "aliases": [
            "Unsupported client_type"
        ]
    },
    {
        "id": 10514,
        "key": "message_10514",
        "ru": "Укажите токен или идентификатор устройства.",
        "en": "Provide a token or device identifier."
    },
    {
        "id": 10515,
        "key": "message_10515",
        "ru": "Укажите код пригласительной ссылки.",
        "en": "Provide the invitation link code."
    },
    {
        "id": 10516,
        "key": "message_10516",
        "ru": "Пригласительная ссылка не найдена или больше не действует.",
        "en": "The invitation link was not found or is no longer valid."
    },
    {
        "id": 10517,
        "key": "message_10517",
        "ru": "Не удалось загрузить уведомления. Попробуйте позже.",
        "en": "Could not load notifications. Try again later.",
        "aliases": [
            "notifications_unavailable"
        ]
    },
    {
        "id": 10518,
        "key": "message_10518",
        "ru": "Запрос на добавление в друзья отправлен!",
        "en": "Friend request sent!"
    },
    {
        "id": 10519,
        "key": "message_10519",
        "ru": "Запрос на добавление в друзья отозван!",
        "en": "Friend request withdrawn!"
    },
    {
        "id": 10520,
        "key": "message_10520",
        "ru": "Запрос на добавление в друзья отклонен и удален!",
        "en": "Friend request declined and deleted!"
    },
    {
        "id": 10521,
        "key": "message_10521",
        "ru": "Запрос на добавление в друзья принят!",
        "en": "Friend request accepted!"
    },
    {
        "id": 10522,
        "key": "message_10522",
        "ru": "Запрос на добавление в друзья завершен!",
        "en": "Friend request completed!"
    },
    {
        "id": 10523,
        "key": "message_10523",
        "ru": "Пользователь успешно удален из друзей.",
        "en": "The user was successfully removed from friends."
    },
    {
        "id": 10524,
        "key": "message_10524",
        "ru": "Запрос на добавление в путешествие отклонен!",
        "en": "Trip join request declined!"
    },
    {
        "id": 10525,
        "key": "message_10525",
        "ru": "Приглашение принято.",
        "en": "Invitation accepted."
    },
    {
        "id": 10526,
        "key": "message_10526",
        "ru": "Запрос на добавление в путешествие завершен!",
        "en": "Trip join request completed!"
    },
    {
        "id": 10527,
        "key": "message_10527",
        "ru": "Изменения сохранены!",
        "en": "Changes saved!"
    },
    {
        "id": 10528,
        "key": "message_10528",
        "ru": "Ваш профиль не найден. Попробуйте войти заново.",
        "en": "Your profile was not found. Try signing in again.",
        "aliases": [
            "Current user profile was not found"
        ]
    },
    {
        "id": 10529,
        "key": "message_10529",
        "ru": "Не удалось определить выбранное уведомление. Обновите страницу.",
        "en": "Could not identify the selected notification. Refresh the page.",
        "aliases": [
            "notification_id must be an integer",
            "user_id, notification_type and notification_id are required",
            "user_id and notification_id are required"
        ]
    },
    {
        "id": 10530,
        "key": "message_10530",
        "ru": "Уведомление не найдено или уже удалено.",
        "en": "The notification was not found or has already been deleted.",
        "aliases": [
            "Notification was not found"
        ]
    },
    {
        "id": 10531,
        "key": "message_10531",
        "ru": "Профиль текущего пользователя не найден.",
        "en": "The current user's profile was not found."
    },
    {
        "id": 10532,
        "key": "message_10532",
        "ru": "Файл не передан.",
        "en": "No file was provided."
    },
    {
        "id": 10533,
        "key": "message_10533",
        "ru": "Ошибка обработки изображения.",
        "en": "Error processing the image."
    },
    {
        "id": 10534,
        "key": "message_10534",
        "ru": "Нет доступа.",
        "en": "Access denied."
    },
    {
        "id": 10535,
        "key": "message_10535",
        "ru": "Не указано имя пользователя!",
        "en": "No username was specified!"
    },
    {
        "id": 10536,
        "key": "message_10536",
        "ru": "Пользователь с таким именем не найден!",
        "en": "No user with this name was found!"
    },
    {
        "id": 10537,
        "key": "message_10537",
        "ru": "Ошибка сервера",
        "en": "Server error"
    },
    {
        "id": 10538,
        "key": "message_10538",
        "ru": "username содержит зарезервированное слово",
        "en": "username contains a reserved word"
    },
    {
        "id": 10539,
        "key": "message_10539",
        "ru": "Этот тип уведомления не поддерживается.",
        "en": "This notification type is not supported.",
        "aliases": [
            "Unsupported notification_type"
        ]
    },
    {
        "id": 10540,
        "key": "message_10540",
        "ru": "Выберите путешествие, для которого покупаете дополнительные лимиты.",
        "en": "Select the trip for which you are purchasing additional limits.",
        "aliases": [
            "travel_plan_id is required for a limit package"
        ]
    },
    {
        "id": 10541,
        "key": "message_10541",
        "ru": "Не удалось начать оплату. Попробуйте позже.",
        "en": "Could not start the payment. Try again later.",
        "aliases": [
            "Failed to initialize payment"
        ]
    },
    {
        "id": 10542,
        "key": "message_10542",
        "ru": "Не удалось определить выбранную покупку. Обновите список предложений.",
        "en": "Could not identify the selected purchase. Refresh the offer list.",
        "aliases": [
            "RuStore product mapping does not match"
        ]
    },
    {
        "id": 10543,
        "key": "message_10543",
        "ru": "Платёж не найден.",
        "en": "Payment not found.",
        "aliases": [
            "Payment transaction not found"
        ]
    },
    {
        "id": 10544,
        "key": "message_10544",
        "ru": "Сумма возврата превышает доступную сумму платежа.",
        "en": "The refund amount exceeds the available payment amount.",
        "aliases": [
            "Refund amount exceeds remaining payment amount"
        ]
    },
    {
        "id": 10545,
        "key": "message_10545",
        "ru": "Эту покупку уже нельзя отменить.",
        "en": "This purchase can no longer be cancelled.",
        "aliases": [
            "Order cannot be cancelled"
        ]
    },
    {
        "id": 10546,
        "key": "message_10546",
        "ru": "Этот способ оплаты не поддерживается.",
        "en": "This payment method is not supported.",
        "aliases": [
            "Unsupported payment provider"
        ]
    },
    {
        "id": 10547,
        "key": "message_10547",
        "ru": "Не удалось отменить оплату. Проверьте её статус позже.",
        "en": "Could not cancel the payment. Check its status later.",
        "aliases": [
            "Provider cancel failed"
        ]
    },
    {
        "id": 10548,
        "key": "message_10548",
        "ru": "Выбранный раздел недоступен.",
        "en": "The selected section is unavailable.",
        "aliases": [
            "Invalid section"
        ]
    },
    {
        "id": 10549,
        "key": "message_10549",
        "ru": "Оплата ещё не подтверждена. Проверьте её статус позже.",
        "en": "Payment has not been confirmed yet. Check its status later.",
        "aliases": [
            "Payment is not confirmed"
        ]
    },
    {
        "id": 10550,
        "key": "message_10550",
        "ru": "Для этого платежа возврат недоступен.",
        "en": "A refund is unavailable for this payment.",
        "aliases": [
            "Payment cannot be refunded"
        ]
    },
    {
        "id": 10551,
        "key": "message_10551",
        "ru": "Не удалось выполнить возврат. Проверьте его статус позже.",
        "en": "Could not issue the refund. Check its status later.",
        "aliases": [
            "Provider refund failed"
        ]
    },
    {
        "id": 10552,
        "key": "message_10552",
        "ru": "Для этой покупки нужны права редактирования путешествия.",
        "en": "You need permission to edit the trip to make this purchase.",
        "aliases": [
            "Travel plan edit access required"
        ]
    },
    {
        "id": 10553,
        "key": "message_10553",
        "ru": "Оплата временно недоступна. Попробуйте позже.",
        "en": "Payment is temporarily unavailable. Try again later.",
        "aliases": [
            "Payment provider is not configured"
        ]
    },
    {
        "id": 10554,
        "key": "message_10554",
        "ru": "Проверка оплаты временно недоступна. Попробуйте позже.",
        "en": "Payment verification is temporarily unavailable. Try again later.",
        "aliases": [
            "RuStore server validation is not configured"
        ]
    },
    {
        "id": 10555,
        "key": "message_10555",
        "ru": "Не удалось проверить оплату. Проверьте её статус позже, прежде чем платить повторно.",
        "en": "Could not verify the payment. Check its status later before paying again.",
        "aliases": [
            "Unable to verify payment with RuStore"
        ]
    },
    {
        "id": 10556,
        "key": "message_10556",
        "ru": "Выбранное путешествие не принадлежит покупателю.",
        "en": "The selected trip does not belong to the purchaser.",
        "aliases": [
            "Target plan does not belong to the purchaser"
        ]
    },
    {
        "id": 10557,
        "key": "message_10557",
        "ru": "Выберите путешествие для этой покупки.",
        "en": "Select a trip for this purchase.",
        "aliases": [
            "travel_plan_id is required for this purchase"
        ]
    },
    {
        "id": 10558,
        "key": "message_10558",
        "ru": "Лимит пробных генераций достигнут. Для гостей он общий для одного IP-адреса. Повторите попытку примерно через {p0} мин. или зарегистрируйтесь, чтобы продолжить планирование.",
        "en": "The trial generation limit has been reached. Guests share this limit per IP address. Try again in about {p0} minutes or register to continue planning.",
        "template": true
    },
    {
        "id": 10559,
        "key": "message_10559",
        "ru": "Дневной лимит пробных ИИ-генераций исчерпан. Попробуйте позже или зарегистрируйтесь, чтобы продолжить планирование.",
        "en": "The daily trial AI generation limit has been reached. Try again later or register to continue planning."
    },
    {
        "id": 10560,
        "key": "message_10560",
        "ru": "Укажите даты, город отправления и направление путешествия.",
        "en": "Provide the dates, departure city and trip destination."
    },
    {
        "id": 10561,
        "key": "message_10561",
        "ru": "Задача генерации не найдена. Обновите страницу.",
        "en": "Generation task not found. Refresh the page.",
        "aliases": [
            "Generation task not found"
        ]
    },
    {
        "id": 10562,
        "key": "message_10562",
        "ru": "Проверьте данные формы.",
        "en": "Check the form data."
    },
    {
        "id": 10563,
        "key": "message_10563",
        "ru": "Не передан предварительный план.",
        "en": "No preliminary plan was provided."
    },
    {
        "id": 10564,
        "key": "message_10564",
        "ru": "Некорректно заполнена форма генерации маршрута.",
        "en": "The route generation form contains invalid data."
    },
    {
        "id": 10565,
        "key": "message_10565",
        "ru": "Для генерации плана на {p0} дн. нужно {p1} AI-токенов. Доступно {p2}. Не хватает {p3}. Минимально докупить {p4} AI-токенов (пакеты по {p5}).",
        "en": "Generating a plan for {p0} days requires {p1} AI tokens. Available: {p2}. Missing: {p3}. Purchase at least {p4} AI tokens (packages of {p5}).",
        "template": true
    },
    {
        "id": 10566,
        "key": "message_10566",
        "ru": "Не удалось создать план. Попробуйте ещё раз немного позже.",
        "en": "Could not create the plan. Try again a little later."
    },
    {
        "id": 10567,
        "key": "message_10567",
        "ru": "Сервис ИИ временно недоступен.",
        "en": "The AI service is temporarily unavailable."
    },
    {
        "id": 10568,
        "key": "message_10568",
        "ru": "Выберите точку на карте.",
        "en": "Select a point on the map.",
        "aliases": [
            "point_id is required"
        ]
    },
    {
        "id": 10569,
        "key": "message_10569",
        "ru": "Введите название места длиной не менее {p0} символов.",
        "en": "Enter a place name with at least {p0} characters.",
        "template": true
    },
    {
        "id": 10570,
        "key": "message_10570",
        "ru": "Точка путешествия не найдена или уже удалена.",
        "en": "The trip point was not found or has already been deleted.",
        "aliases": [
            "Plan point not found"
        ]
    },
    {
        "id": 10571,
        "key": "message_10571",
        "ru": "У вас нет доступа к этой точке путешествия.",
        "en": "You do not have access to this trip point.",
        "aliases": [
            "No access to this travel point"
        ]
    },
    {
        "id": 10572,
        "key": "message_10572",
        "ru": "Не удалось загрузить данные бронирования. Попробуйте позже.",
        "en": "Could not load booking data. Try again later.",
        "aliases": [
            "Failed to load travel item booking data"
        ]
    },
    {
        "id": 10573,
        "key": "message_10573",
        "ru": "Не удалось обновить данные бронирования. Попробуйте позже.",
        "en": "Could not update booking data. Try again later.",
        "aliases": [
            "Failed to refresh travel item booking data"
        ]
    },
    {
        "id": 10574,
        "key": "message_10574",
        "ru": "Ошибка генерации GPT-описания.",
        "en": "Error generating the GPT description."
    },
    {
        "id": 10575,
        "key": "message_10575",
        "ru": "Внутренняя ошибка",
        "en": "Internal error"
    },
    {
        "id": 10576,
        "key": "message_10576",
        "ru": "Р’РЅСѓС‚СЂРµРЅРЅСЏСЏ РѕС€РёР±РєР°",
        "en": "Internal error"
    },
    {
        "id": 10577,
        "key": "message_10577",
        "ru": "Укажите даты начала и окончания.",
        "en": "Provide the start and end dates.",
        "aliases": [
            "date_from and date_to are required"
        ]
    },
    {
        "id": 10578,
        "key": "message_10578",
        "ru": "Нет прав на изменение бронирований.",
        "en": "You do not have permission to change bookings."
    },
    {
        "id": 10579,
        "key": "message_10579",
        "ru": "Не удалось проверить принадлежность бронирований.",
        "en": "Could not verify booking ownership."
    },
    {
        "id": 10580,
        "key": "message_10580",
        "ru": "Не удалось поставить генерацию точек в очередь.",
        "en": "Could not queue point generation."
    },
    {
        "id": 10581,
        "key": "message_10581",
        "ru": "Фильтр бронирований не соответствует путешествию.",
        "en": "The booking filter does not match the trip."
    },
    {
        "id": 10582,
        "key": "message_10582",
        "ru": "Не удалось поставить генерацию финансов в очередь.",
        "en": "Could not queue financial generation."
    },
    {
        "id": 10583,
        "key": "message_10583",
        "ru": "Исправлены даты выселения позже окончания путешествия: {p0}.",
        "en": "Check-out dates later than the trip end date were corrected: {p0}.",
        "template": true
    },
    {
        "id": 10584,
        "key": "message_10584",
        "ru": "Не удалось проверить связность маршрута: route skeleton пуст.",
        "en": "Could not check route connectivity: the route skeleton is empty."
    },
    {
        "id": 10585,
        "key": "message_10585",
        "ru": "Дополнительная проверка логики плана пропущена: закончился лимит AI-токенов.",
        "en": "The additional plan logic check was skipped because the AI token limit was reached."
    },
    {
        "id": 10586,
        "key": "message_10586",
        "ru": "Не удалось выполнить дополнительную проверку логики плана.",
        "en": "Could not perform the additional plan logic check."
    },
    {
        "id": 10587,
        "key": "message_10587",
        "ru": "Пользователь обязателен",
        "en": "A user is required"
    },
    {
        "id": 10588,
        "key": "message_10588",
        "ru": "Исходный текст должен быть не менее {p0} символов",
        "en": "The source text must contain at least {p0} characters",
        "template": true,
        "public_translation": true
    },
    {
        "id": 10589,
        "key": "message_10589",
        "ru": "В плане поездки пока нет пунктов. Добавьте хотя бы один пункт вручную или создайте план с ИИ, затем запустите прогноз расходов.",
        "en": "The trip plan has no items yet. Add at least one item manually or create a plan with AI, then generate the expense forecast.",
        "public_translation": true,
        "aliases": [
            "Travel plan has no items for finance generation",
            "Добавьте пункты в план путешествия перед расчётом расходов.",
            "generation_finance_requires_items"
        ]
    },
    {
        "id": 10590,
        "key": "message_10590",
        "ru": "Финансовый прогноз не содержит валидных расходов",
        "en": "The financial forecast contains no valid expenses"
    },
    {
        "id": 10591,
        "key": "message_10591",
        "ru": "Лимит GPT исчерпан",
        "en": "The GPT limit has been reached"
    },
    {
        "id": 10592,
        "key": "message_10592",
        "ru": "Ответ GPT по точкам должен быть объектом",
        "en": "The GPT points response must be an object"
    },
    {
        "id": 10593,
        "key": "message_10593",
        "ru": "В плане поездки пока нет пунктов. Добавьте хотя бы один пункт вручную или создайте план с ИИ, затем запустите генерацию точек и треков.",
        "en": "The trip plan has no items yet. Add at least one item manually or create a plan with AI, then generate points and tracks.",
        "public_translation": true,
        "aliases": [
            "В плане нет пунктов для генерации точек",
            "The plan has no items for point generation",
            "generation_points_requires_items"
        ]
    },
    {
        "id": 10594,
        "key": "message_10594",
        "ru": "Не удалось определить ни одной валидной точки маршрута",
        "en": "Could not identify any valid route points"
    },
    {
        "id": 10595,
        "key": "message_10595",
        "ru": "Не удалось сохранить ни одной сгенерированной точки: все точки не прошли проверку.",
        "en": "Could not save any generated points: none passed validation."
    },
    {
        "id": 10596,
        "key": "message_10596",
        "ru": "Введите название места для поиска.",
        "en": "Enter a place name to search for.",
        "aliases": [
            "text_query is empty"
        ]
    },
    {
        "id": 10597,
        "key": "message_10597",
        "ru": "Не удалось определить выбранную точку. Обновите страницу.",
        "en": "Could not identify the selected point. Refresh the page.",
        "aliases": [
            "Invalid point_id"
        ]
    },
    {
        "id": 10598,
        "key": "message_10598",
        "ru": "Некорректный параметр {p0}",
        "en": "Invalid parameter {p0}",
        "template": true
    },
    {
        "id": 10599,
        "key": "message_10599",
        "ru": "{p0} не может быть больше {p1}",
        "en": "{p0} cannot be greater than {p1}",
        "template": true
    },
    {
        "id": 10600,
        "key": "message_10600",
        "ru": "Поле message обязательно.",
        "en": "The message field is required."
    },
    {
        "id": 10601,
        "key": "message_10601",
        "ru": "Ошибка получения каталога маршрутов.",
        "en": "Error retrieving the route catalogue."
    },
    {
        "id": 10602,
        "key": "message_10602",
        "ru": "Ошибка получения справочника типов GPX",
        "en": "Error retrieving the GPX type dictionary"
    },
    {
        "id": 10603,
        "key": "message_10603",
        "ru": "Ошибка получения справочника статусов (личные)",
        "en": "Error retrieving the personal status dictionary"
    },
    {
        "id": 10604,
        "key": "message_10604",
        "ru": "Ошибка получения справочника статусов (публичные)",
        "en": "Error retrieving the public status dictionary"
    },
    {
        "id": 10605,
        "key": "message_10605",
        "ru": "Ошибка получения справочника типов путешествий",
        "en": "Error retrieving the trip type dictionary"
    },
    {
        "id": 10606,
        "key": "message_10606",
        "ru": "Ошибка получения справочника типов тарифов",
        "en": "Error retrieving the plan type dictionary"
    },
    {
        "id": 10607,
        "key": "message_10607",
        "ru": "Ошибка получения справочника стран",
        "en": "Error retrieving the country dictionary"
    },
    {
        "id": 10608,
        "key": "message_10608",
        "ru": "Ошибка получения справочника валют",
        "en": "Error retrieving the currency dictionary"
    },
    {
        "id": 10609,
        "key": "message_10609",
        "ru": "Ошибка получения публичных путешествий по странам.",
        "en": "Error retrieving public trips by country."
    },
    {
        "id": 10610,
        "key": "message_10610",
        "ru": "Ошибка получения случайных публичных путешествий.",
        "en": "Error retrieving random public trips."
    },
    {
        "id": 10611,
        "key": "message_10611",
        "ru": "Не удалось загрузить предложения. Попробуйте позже.",
        "en": "Could not load offers. Try again later.",
        "aliases": [
            "Failed to fetch travel packages"
        ]
    },
    {
        "id": 10612,
        "key": "message_10612",
        "ru": "Некорректная страница",
        "en": "Invalid page"
    },
    {
        "id": 10613,
        "key": "message_10613",
        "ru": "Неизвестная страна",
        "en": "Unknown country"
    },
    {
        "id": 10614,
        "key": "message_10614",
        "ru": "Адреса разделов должны быть уникальными.",
        "en": "Section addresses must be unique."
    },
    {
        "id": 10615,
        "key": "message_10615",
        "ru": "Один из скриншотов не найден. Загрузите его повторно.",
        "en": "One of the screenshots was not found. Upload it again."
    },
    {
        "id": 10616,
        "key": "message_10616",
        "ru": "Доступ разрешён только администратору.",
        "en": "Access is limited to administrators."
    },
    {
        "id": 10617,
        "key": "message_10617",
        "ru": "Некорректная версия документа или действие.",
        "en": "Invalid document version or action."
    },
    {
        "id": 10618,
        "key": "message_10618",
        "ru": "Выберите изображение размером до 25 МБ.",
        "en": "Select an image of up to 25 MB."
    },
    {
        "id": 10619,
        "key": "message_10619",
        "ru": "Инструкция уже изменена другим администратором. Сохраните свой текст отдельно и обновите страницу.",
        "en": "Another administrator has already changed the guide. Save your text separately and refresh the page."
    },
    {
        "id": 10620,
        "key": "message_10620",
        "ru": "Поле {p0} не может быть отрицательным.",
        "en": "The {p0} field cannot be negative.",
        "template": true
    },
    {
        "id": 10621,
        "key": "message_10621",
        "ru": "Поле {p0} должно быть 1, 2, 3.",
        "en": "The {p0} field must be 1, 2 or 3.",
        "template": true
    },
    {
        "id": 10622,
        "key": "message_10622",
        "ru": "Поле {p0} должно быть web или rustore.",
        "en": "The {p0} field must be web or rustore.",
        "template": true
    },
    {
        "id": 10623,
        "key": "message_10623",
        "ru": "Поле {p0} должно быть целым числом.",
        "en": "The {p0} field must be an integer.",
        "template": true
    },
    {
        "id": 10624,
        "key": "message_10624",
        "ru": "Ошибка получения справочников пакетов.",
        "en": "Error retrieving package dictionaries."
    },
    {
        "id": 10625,
        "key": "message_10625",
        "ru": "Поле name обязательно.",
        "en": "The name field is required."
    },
    {
        "id": 10626,
        "key": "message_10626",
        "ru": "Ошибка создания набора лимитов.",
        "en": "Error creating the limit set."
    },
    {
        "id": 10627,
        "key": "message_10627",
        "ru": "Ошибка обновления набора лимитов.",
        "en": "Error updating the limit set."
    },
    {
        "id": 10628,
        "key": "message_10628",
        "ru": "Нельзя удалить: набор лимитов используется в пакетах.",
        "en": "Cannot delete: the limit set is used by packages."
    },
    {
        "id": 10629,
        "key": "message_10629",
        "ru": "Ошибка удаления набора лимитов.",
        "en": "Error deleting the limit set."
    },
    {
        "id": 10630,
        "key": "message_10630",
        "ru": "Поле price не может быть отрицательным.",
        "en": "The price field cannot be negative."
    },
    {
        "id": 10631,
        "key": "message_10631",
        "ru": "Ошибка создания пакета путешествий.",
        "en": "Error creating the trip package."
    },
    {
        "id": 10632,
        "key": "message_10632",
        "ru": "Ошибка обновления пакета путешествий.",
        "en": "Error updating the trip package."
    },
    {
        "id": 10633,
        "key": "message_10633",
        "ru": "Нельзя удалить: пакет используется в других данных.",
        "en": "Cannot delete: the package is used by other data."
    },
    {
        "id": 10634,
        "key": "message_10634",
        "ru": "Ошибка удаления пакета путешествий.",
        "en": "Error deleting the trip package."
    },
    {
        "id": 10635,
        "key": "message_10635",
        "ru": "Ошибка переключения архива пакета.",
        "en": "Error changing the package archive status."
    },
    {
        "id": 10636,
        "key": "message_10636",
        "ru": "Поле name не может быть пустым.",
        "en": "The name field cannot be empty."
    },
    {
        "id": 10637,
        "key": "message_10637",
        "ru": "Поле price должно быть числом.",
        "en": "The price field must be a number."
    },
    {
        "id": 10638,
        "key": "message_10638",
        "ru": "Секции должны быть переданы списком.",
        "en": "Sections must be provided as a list."
    },
    {
        "id": 10639,
        "key": "message_10639",
        "ru": "На странице может быть не более {p0} секций.",
        "en": "The page may contain no more than {p0} sections.",
        "template": true
    },
    {
        "id": 10640,
        "key": "message_10640",
        "ru": "Slug должен содержать только латинские буквы, цифры и дефисы.",
        "en": "The slug may contain only Latin letters, digits and hyphens."
    },
    {
        "id": 10641,
        "key": "message_10641",
        "ru": "Выбрана неизвестная группа направления.",
        "en": "An unknown destination group was selected."
    },
    {
        "id": 10642,
        "key": "message_10642",
        "ru": "Поле публикации должно быть логическим значением.",
        "en": "The publication field must be a boolean."
    },
    {
        "id": 10643,
        "key": "message_10643",
        "ru": "Можно выбрать не более {p0} маршрутов.",
        "en": "You can select no more than {p0} routes.",
        "template": true
    },
    {
        "id": 10644,
        "key": "message_10644",
        "ru": "Один или несколько выбранных маршрутов не найдены.",
        "en": "One or more selected routes were not found."
    },
    {
        "id": 10645,
        "key": "message_10645",
        "ru": "Секция {p0} имеет неверный формат.",
        "en": "Section {p0} has an invalid format.",
        "template": true
    },
    {
        "id": 10646,
        "key": "message_10646",
        "ru": "Заполните заголовок и текст секции {p0}.",
        "en": "Provide the heading and text for section {p0}.",
        "template": true
    },
    {
        "id": 10647,
        "key": "message_10647",
        "ru": "Заголовок секции {p0} слишком длинный.",
        "en": "The heading of section {p0} is too long.",
        "template": true
    },
    {
        "id": 10648,
        "key": "message_10648",
        "ru": "Текст секции {p0} слишком длинный.",
        "en": "The text of section {p0} is too long.",
        "template": true
    },
    {
        "id": 10649,
        "key": "message_10649",
        "ru": "Для публикации нужен уникальный материал объёмом не менее {p0} слов.",
        "en": "Publication requires original content of at least {p0} words.",
        "template": true
    },
    {
        "id": 10650,
        "key": "message_10650",
        "ru": "Для публикации укажите автора или редактора.",
        "en": "Specify an author or editor to publish."
    },
    {
        "id": 10651,
        "key": "message_10651",
        "ru": "Для публикации выберите хотя бы один корректный маршрут.",
        "en": "Select at least one valid route to publish."
    },
    {
        "id": 10652,
        "key": "message_10652",
        "ru": "Такой текст уже опубликован на другой SEO-странице.",
        "en": "This text has already been published on another SEO page."
    },
    {
        "id": 10653,
        "key": "message_10653",
        "ru": "Не удалось сохранить обложку. Попробуйте ещё раз.",
        "en": "Could not save the cover. Try again."
    },
    {
        "id": 10654,
        "key": "message_10654",
        "ru": "Сервис временно недоступен. Повторите запрос позже.",
        "en": "The service is temporarily unavailable. Repeat the request later."
    },
    {
        "id": 12000,
        "key": "message_12000",
        "ru": "Сумма платежа не совпадает со стоимостью покупки. Обратитесь в поддержку.",
        "en": "The payment amount does not match the purchase price. Contact support.",
        "aliases": [
            "Invoice amount does not match"
        ]
    },
    {
        "id": 12001,
        "key": "message_12001",
        "ru": "Вы не можете добавить себя в друзья!",
        "en": "You cannot add yourself as a friend!"
    },
    {
        "id": 12002,
        "key": "message_12002",
        "ru": "Данные предварительного плана больше недоступны",
        "en": "The preliminary plan data is no longer available"
    },
    {
        "id": 12003,
        "key": "message_12003",
        "ru": "Дата окончания путешествия не может быть раньше даты начала.",
        "en": "The trip end date cannot be earlier than the start date."
    },
    {
        "id": 12004,
        "key": "message_12004",
        "ru": "Для генерации плана укажите даты начала и окончания путешествия.",
        "en": "Provide the trip start and end dates to generate a plan."
    },
    {
        "id": 12005,
        "key": "message_12005",
        "ru": "Для путешествия не указана страна",
        "en": "No country is specified for this trip"
    },
    {
        "id": 12006,
        "key": "message_12006",
        "ru": "Для стран путешествия не настроены валюты",
        "en": "Currencies have not been configured for the trip countries"
    },
    {
        "id": 12007,
        "key": "message_12007",
        "ru": "Добавьте страну в путешествие перед переносом плана",
        "en": "Add a country to the trip before transferring the plan"
    },
    {
        "id": 12008,
        "key": "message_12008",
        "ru": "Запрос на добавление уже был отправлен!",
        "en": "An add request has already been sent!"
    },
    {
        "id": 12009,
        "key": "message_12009",
        "ru": "ИИ не вернул пункты для предварительного плана",
        "en": "The AI did not return items for the preliminary plan"
    },
    {
        "id": 12010,
        "key": "message_12010",
        "ru": "Лимит GPX-треков этого путешествия исчерпан.",
        "en": "The GPX track limit for this trip has been reached."
    },
    {
        "id": 12011,
        "key": "message_12011",
        "ru": "Лимит ИИ для этого путешествия исчерпан. Пополните лимит, чтобы продолжить.",
        "en": "The AI limit for this trip has been reached. Purchase more credits to continue.",
        "aliases": [
            "Лимит AI-токенов этого путешествия исчерпан"
        ]
    },
    {
        "id": 12012,
        "key": "message_12012",
        "ru": "Лимиты для создания пунктов плана закончились",
        "en": "The limit for creating plan items has been reached"
    },
    {
        "id": 12013,
        "key": "message_12013",
        "ru": "Лимиты для создания точек на карте закончились",
        "en": "The limit for creating map points has been reached"
    },
    {
        "id": 12014,
        "key": "message_12014",
        "ru": "Не удалось активировать покупку. Обратитесь в поддержку.",
        "en": "Could not activate the purchase. Contact support.",
        "aliases": [
            "Purchase activation failed"
        ]
    },
    {
        "id": 12015,
        "key": "message_12015",
        "ru": "Не удалось определить тип тарифа для списания лимита.",
        "en": "Could not determine the plan type for deducting the limit."
    },
    {
        "id": 12016,
        "key": "message_12016",
        "ru": "Не удалось проверить статус оплаты. Попробуйте позже.",
        "en": "Could not check the payment status. Try again later.",
        "aliases": [
            "Payment reconciliation failed"
        ]
    },
    {
        "id": 12017,
        "key": "message_12017",
        "ru": "Не удалось сгенерировать username",
        "en": "Could not generate a username"
    },
    {
        "id": 12018,
        "key": "message_12018",
        "ru": "Не удалось сохранить ни одной сгенерированной плановой траты.",
        "en": "Could not save any generated planned expenses."
    },
    {
        "id": 12019,
        "key": "message_12019",
        "ru": "Не удалось удалить пользователя из друзей.",
        "en": "Could not remove the user from friends."
    },
    {
        "id": 12020,
        "key": "message_12020",
        "ru": "Недостаточно {p0} путешествий по выбранному тарифу.",
        "en": "There are not enough {p0} trips on the selected plan.",
        "template": true
    },
    {
        "id": 12021,
        "key": "message_12021",
        "ru": "Некорректные данные предварительного плана",
        "en": "Invalid preliminary plan data"
    },
    {
        "id": 12022,
        "key": "message_12022",
        "ru": "Некорректный идентификатор предварительного плана",
        "en": "Invalid preliminary plan identifier"
    },
    {
        "id": 12023,
        "key": "message_12023",
        "ru": "Неподдерживаемый тип: {p0}",
        "en": "Unsupported type: {p0}",
        "template": true
    },
    {
        "id": 12024,
        "key": "message_12024",
        "ru": "Пользователь запретил приглашения в друзья.",
        "en": "The user has disabled friend invitations."
    },
    {
        "id": 12025,
        "key": "message_12025",
        "ru": "Предварительный план не найден или срок ожидания истёк",
        "en": "The preliminary plan was not found or the waiting period has expired"
    },
    {
        "id": 12026,
        "key": "message_12026",
        "ru": "Предварительный план не найден или срок ссылки истёк",
        "en": "The preliminary plan was not found or the link has expired"
    },
    {
        "id": 12027,
        "key": "message_12027",
        "ru": "Приглашение больше недоступно. Возможно, отправитель его отозвал.",
        "en": "The invitation is no longer available. The sender may have withdrawn it."
    },
    {
        "id": 12028,
        "key": "message_12028",
        "ru": "Редактирование группы доступно только для перемещения.",
        "en": "Group editing is available only for movements."
    },
    {
        "id": 12029,
        "key": "message_12029",
        "ru": "Редактируемое перемещение не найдено.",
        "en": "The movement being edited was not found."
    },
    {
        "id": 12030,
        "key": "message_12030",
        "ru": "Сервис ИИ не вернул идентификатор генерации",
        "en": "The AI service did not return a generation identifier"
    },
    {
        "id": 12031,
        "key": "message_12031",
        "ru": "Справочник категорий расходов пуст",
        "en": "The expense category dictionary is empty"
    },
    {
        "id": 12032,
        "key": "message_12032",
        "ru": "Такой план уже создаётся. Повторите запрос через несколько секунд",
        "en": "This plan is already being created. Repeat the request in a few seconds"
    },
    {
        "id": 12033,
        "key": "message_12033",
        "ru": "Точки относятся к другому пункту путешествия.",
        "en": "The points belong to another trip item."
    },
    {
        "id": 12034,
        "key": "message_12034",
        "ru": "Финансы путешествия не настроены",
        "en": "Trip finances have not been configured"
    },
    {
        "id": 12035,
        "key": "message_12035",
        "ru": "Фотографии не принадлежат редактируемому перемещению.",
        "en": "The photos do not belong to the movement being edited."
    },
    {
        "id": 12036,
        "key": "message_12036",
        "ru": "Хранилище не подтвердило сохранение файла: {p0}",
        "en": "Storage did not confirm that the file was saved: {p0}",
        "template": true
    },
    {
        "id": 12037,
        "key": "message_12037",
        "ru": "Этот пользователь уже является вашим другом!",
        "en": "This user is already your friend!"
    },
    {
        "id": 13000,
        "key": "message_13000",
        "ru": "Некорректные данные дня путешествия.",
        "en": "Each day must be an object",
        "public_translation": true
    },
    {
        "id": 13001,
        "key": "message_13001",
        "ru": "Для каждого дня необходимо указать дату.",
        "en": "Each day must have date",
        "public_translation": true
    },
    {
        "id": 13002,
        "key": "message_13002",
        "ru": "Некорректный тип трека.",
        "en": "Invalid gpx_type",
        "public_translation": true
    },
    {
        "id": 13003,
        "key": "message_13003",
        "ru": "Некорректный идентификатор счёта.",
        "en": "Invalid invoice id",
        "public_translation": true
    },
    {
        "id": 13004,
        "key": "message_13004",
        "ru": "Некорректный код товара.",
        "en": "Invalid product_code format",
        "public_translation": true
    },
    {
        "id": 13005,
        "key": "message_13005",
        "ru": "В счёте отсутствует сумма.",
        "en": "Invoice amount is missing",
        "public_translation": true
    },
    {
        "id": 13006,
        "key": "message_13006",
        "ru": "Типы расходов пока не настроены.",
        "en": "No expense types configured",
        "public_translation": true
    },
    {
        "id": 13007,
        "key": "message_13007",
        "ru": "Исходный текст должен содержать не менее {p0} символов.",
        "en": "Original text must be at least {p0} characters",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13008,
        "key": "message_13008",
        "ru": "Стоимость товара не может быть отрицательной.",
        "en": "Product price cannot be negative",
        "public_translation": true
    },
    {
        "id": 13009,
        "key": "message_13009",
        "ru": "Для чека необходимо указать электронную почту или телефон покупателя.",
        "en": "Receipt requires customer email or phone",
        "public_translation": true
    },
    {
        "id": 13010,
        "key": "message_13010",
        "ru": "Нельзя приглашать самого себя по реферальной ссылке.",
        "en": "Self-referral is not allowed.",
        "public_translation": true
    },
    {
        "id": 13011,
        "key": "message_13011",
        "ru": "Операция оплаты не подтверждена.",
        "en": "Transaction is not confirmed",
        "public_translation": true
    },
    {
        "id": 13012,
        "key": "message_13012",
        "ru": "Превышена частота запросов построения маршрута. Попробуйте позже.",
        "en": "Mapbox directions rate limit exceeded",
        "public_translation": true
    },
    {
        "id": 13013,
        "key": "message_13013",
        "ru": "Превышена частота запросов к сервису карт. Попробуйте позже.",
        "en": "Mapbox rate limit exceeded",
        "public_translation": true
    },
    {
        "id": 13014,
        "key": "message_13014",
        "ru": "Хранилище не подтвердило загрузку изображения. Проверьте результат загрузки.",
        "en": "Image storage did not confirm the upload",
        "public_translation": true
    },
    {
        "id": 13015,
        "key": "message_13015",
        "ru": "Расход пропущен: некорректная сумма.",
        "en": "Skipped expense with invalid amount",
        "public_translation": true
    },
    {
        "id": 13016,
        "key": "message_13016",
        "ru": "Расход пропущен: не указан тип расхода.",
        "en": "Skipped expense without type_expense_id",
        "public_translation": true
    },
    {
        "id": 13017,
        "key": "message_13017",
        "ru": "Расход пропущен: не указана допустимая страна.",
        "en": "Skipped expense without valid country_id",
        "public_translation": true
    },
    {
        "id": 13018,
        "key": "message_13018",
        "ru": "Расход пропущен: не указана допустимая валюта.",
        "en": "Skipped expense without valid currency_id",
        "public_translation": true
    },
    {
        "id": 13019,
        "key": "message_13019",
        "ru": "Пропущен повторный расход на границе путешествия для пункта {p0}.",
        "en": "Skipped duplicate boundary expense for item_id={p0}",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13020,
        "key": "message_13020",
        "ru": "Расход пропущен: некорректный идентификатор страны {p0}.",
        "en": "Skipped expense with invalid country_id={p0}",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13021,
        "key": "message_13021",
        "ru": "Расход пропущен: некорректная дата для пункта {p0}.",
        "en": "Skipped expense with invalid date for item_id={p0}",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13022,
        "key": "message_13022",
        "ru": "Расход пропущен: некорректный идентификатор типа расхода {p0}.",
        "en": "Skipped expense with invalid type_expense_id={p0}",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13023,
        "key": "message_13023",
        "ru": "Пропущен неизвестный пункт {p0}.",
        "en": "Skipped unknown item_id={p0}",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13024,
        "key": "message_13024",
        "ru": "Расход путешествия пропущен: дата находится вне его границ.",
        "en": "Skipped trip-level expense outside trip boundary dates",
        "public_translation": true
    },
    {
        "id": 13025,
        "key": "message_13025",
        "ru": "Расход путешествия пропущен: для этого типа расхода требуется пункт.",
        "en": "Skipped unsupported trip-level expense without item_id",
        "public_translation": true
    },
    {
        "id": 13026,
        "key": "message_13026",
        "ru": "Расход пропущен: валюта {p0} недоступна для страны {p1}.",
        "en": "Skipped expense: currency_id={p0} is not allowed for country_id={p1}",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13027,
        "key": "message_13027",
        "ru": "День {p0}: сгенерированное название пункта сокращено до {p1} символов.",
        "en": "Day {p0}: generated item name trimmed to {p1} chars",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13028,
        "key": "message_13028",
        "ru": "День {p0}: название пункта сокращено до {p1} символов.",
        "en": "Day {p0}: item name trimmed to {p1} chars",
        "public_translation": true,
        "template": true
    },
    {
        "id": 13029,
        "key": "message_13029",
        "ru": "Неподдерживаемый платёжный сервис.",
        "en": "Unsupported payment provider",
        "public_translation": true
    },
    {
        "id": 13030,
        "key": "message_13030",
        "ru": "Реферальная программа для этого аккаунта недоступна.",
        "en": "Referral account is blocked",
        "public_translation": true
    },
    {
        "id": 13031,
        "key": "message_13031",
        "ru": "Дата окончания не может быть раньше даты начала.",
        "en": "date_to must be greater than or equal to date_from",
        "public_translation": true
    },
    {
        "id": 13032,
        "key": "message_13032",
        "ru": "Смещение списка не может быть отрицательным.",
        "en": "offset must be greater than or equal to 0",
        "public_translation": true
    },
    {
        "id": 13033,
        "key": "message_13033",
        "ru": "Состояние не может быть пустым.",
        "en": "state cannot be empty",
        "public_translation": true
    },
    {
        "id": 13034,
        "key": "message_13034",
        "ru": "Дополнительные данные должны быть объектом.",
        "en": "metadata must be an object",
        "public_translation": true
    },
    {
        "id": 13035,
        "key": "message_13035",
        "ru": "Результаты должны быть списком.",
        "en": "results must be a list",
        "public_translation": true
    },
    {
        "id": 13036,
        "key": "message_13036",
        "ru": "Предупреждения должны быть списком.",
        "en": "warnings must be a list",
        "public_translation": true
    },
    {
        "id": 13037,
        "key": "message_13037",
        "ru": "План должен быть списком.",
        "en": "plan must be a list",
        "public_translation": true
    },
    {
        "id": 13038,
        "key": "message_13038",
        "ru": "Пункты дня должны быть списком.",
        "en": "day.items must be a list",
        "public_translation": true
    },
    {
        "id": 13039,
        "key": "message_13039",
        "ru": "Параметры пункта должны быть списком.",
        "en": "item.params must be a list",
        "public_translation": true
    },
    {
        "id": 20001,
        "key": "message_20001",
        "ru": "Вложения превышают 30 МБ.",
        "en": "Attachments exceed 30 MB.",
        "public_translation": true
    },
    {
        "id": 20002,
        "key": "message_20002",
        "ru": "День для переименования не найден.",
        "en": "The day to rename was not found.",
        "public_translation": true
    },
    {
        "id": 20003,
        "key": "message_20003",
        "ru": "Локальные изменения доступны только автору личного путешествия.",
        "en": "Local changes are available only to the owner of a personal trip.",
        "public_translation": true
    },
    {
        "id": 20004,
        "key": "message_20004",
        "ru": "Название дня не должно превышать 120 символов.",
        "en": "The day name must not exceed 120 characters.",
        "public_translation": true
    },
    {
        "id": 20005,
        "key": "message_20005",
        "ru": "Не удалось выполнить поиск. Повторите попытку.",
        "en": "Search failed. Please try again.",
        "public_translation": true
    },
    {
        "id": 20006,
        "key": "message_20006",
        "ru": "Не удалось определить изменяемую запись.",
        "en": "Unable to identify the record to edit.",
        "public_translation": true
    },
    {
        "id": 20007,
        "key": "message_20007",
        "ru": "Не удалось определить пункт локального действия.",
        "en": "Unable to identify the item for the local operation.",
        "public_translation": true
    },
    {
        "id": 20008,
        "key": "message_20008",
        "ru": "Не удалось получить связанные данные плана.",
        "en": "Unable to load related plan data.",
        "public_translation": true
    },
    {
        "id": 20009,
        "key": "message_20009",
        "ru": "Неизвестное действие с планом.",
        "en": "Unknown plan operation.",
        "public_translation": true
    },
    {
        "id": 20010,
        "key": "message_20010",
        "ru": "Неизвестное локальное действие.",
        "en": "Unknown local operation.",
        "public_translation": true
    },
    {
        "id": 20011,
        "key": "message_20011",
        "ru": "Некорректная дата дня.",
        "en": "Invalid day date.",
        "public_translation": true
    },
    {
        "id": 20012,
        "key": "message_20012",
        "ru": "Некорректная локальная операция.",
        "en": "Invalid local operation.",
        "public_translation": true
    },
    {
        "id": 20013,
        "key": "message_20013",
        "ru": "Некорректные пункты дня.",
        "en": "Invalid day items.",
        "public_translation": true
    },
    {
        "id": 20014,
        "key": "message_20014",
        "ru": "Некорректный список удаляемых пунктов.",
        "en": "Invalid list of items to delete.",
        "public_translation": true
    },
    {
        "id": 20015,
        "key": "message_20015",
        "ru": "Отправляйте от 1 до 100 изменений плана за один раз.",
        "en": "Send between 1 and 100 plan changes at a time.",
        "public_translation": true
    },
    {
        "id": 20016,
        "key": "message_20016",
        "ru": "Передайте одну изменяемую точку.",
        "en": "Submit one point to edit.",
        "public_translation": true
    },
    {
        "id": 20017,
        "key": "message_20017",
        "ru": "Повторяющееся действие с планом.",
        "en": "Duplicate plan operation.",
        "public_translation": true
    },
    {
        "id": 20018,
        "key": "message_20018",
        "ru": "Пункт для отметки выполнения не найден.",
        "en": "The item to mark as completed was not found.",
        "public_translation": true
    },
    {
        "id": 20019,
        "key": "message_20019",
        "ru": "Трек не принадлежит пункту путешествия.",
        "en": "The track does not belong to this trip item.",
        "public_translation": true
    },
    {
        "id": 20020,
        "key": "message_20020",
        "ru": "У выбранного дня путешествия не указана дата.",
        "en": "The selected trip day has no date.",
        "public_translation": true
    },
    {
        "id": 20021,
        "key": "message_20021",
        "ru": "Удаляемый пункт не принадлежит путешествию или уже удалён.",
        "en": "The item to delete does not belong to this trip or has already been deleted.",
        "public_translation": true
    },
    {
        "id": 20022,
        "key": "message_20022",
        "ru": "Укажите название трека до 120 символов.",
        "en": "Enter a track name of up to 120 characters.",
        "public_translation": true
    },
    {
        "id": 20023,
        "key": "message_20023",
        "ru": "Укажите отметку выполнения.",
        "en": "Specify whether the item is completed.",
        "public_translation": true
    },
    {
        "id": 20024,
        "key": "message_20024",
        "ru": "Выберите тип пункта путешествия.",
        "en": "Select a trip item type.",
        "public_translation": true,
        "aliases": [
            "Поле item_type_id обязательно и должно быть числом.",
            "Указанный тип пункта (item_type) не найден.",
            "Некорректный формат item_type."
        ]
    },
    {
        "id": 20025,
        "key": "message_20025",
        "ru": "Выберите тип точки.",
        "en": "Select a point type.",
        "public_translation": true,
        "aliases": [
            "Не указан point_type_id",
            "point_type_id обязателен (глобально или в каждой точке)",
            "Для пункта перемещения не указан point_type_id",
            "Указанный тип точки (point_type) не найден.",
            "Некорректный формат point_type."
        ]
    },
    {
        "id": 20026,
        "key": "message_20026",
        "ru": "Все точки должны относиться к выбранному пункту путешествия.",
        "en": "All points must belong to the selected trip item.",
        "public_translation": true,
        "aliases": [
            "item_id в points должен совпадать с item_id запроса",
            "item_id в points должен совпадать с общим item_id"
        ]
    },
    {
        "id": 20027,
        "key": "message_20027",
        "ru": "Выберите страну путешествия. Если список пуст, добавьте страну в план.",
        "en": "Select a trip country. If the list is empty, add a country to the plan.",
        "public_translation": true,
        "aliases": [
            "Не удалось определить страну: передайте selected_countries или добавьте страну в план."
        ]
    },
    {
        "id": 20028,
        "key": "message_20028",
        "ru": "Не удалось прочитать список точек. Повторите выбор точек на карте.",
        "en": "Unable to read the point list. Select the points on the map again.",
        "public_translation": true,
        "aliases": [
            "Некорректное поле points: ожидался JSON-массив.",
            "Неверный формат points (ожидается JSON)",
            "Неверный формат JSON"
        ]
    },
    {
        "id": 20029,
        "key": "message_20029",
        "ru": "Точка должна содержать название и координаты.",
        "en": "A point must contain a name and coordinates.",
        "public_translation": true,
        "aliases": [
            "Точка должна быть объектом JSON"
        ]
    },
    {
        "id": 20030,
        "key": "message_20030",
        "ru": "Отметьте, взято ли снаряжение.",
        "en": "Specify whether the equipment is packed.",
        "public_translation": true,
        "aliases": [
            "Поле is_checked должно быть булевым значением."
        ]
    },
    {
        "id": 20031,
        "key": "message_20031",
        "ru": "Выбранный тип точки не найден. Выберите тип ещё раз.",
        "en": "The selected point type was not found. Select the type again.",
        "public_translation": true
    },
    {
        "id": 20032,
        "key": "message_20032",
        "ru": "Название должно содержать не более {p0} символов.",
        "en": "The name must not exceed {p0} characters.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20033,
        "key": "message_20033",
        "ru": "Не удалось определить пункт для файла. Выберите пункт путешествия ещё раз.",
        "en": "Unable to identify the item for the file. Select the trip item again.",
        "public_translation": true
    },
    {
        "id": 20034,
        "key": "message_20034",
        "ru": "Название файла должно содержать от 1 до 200 символов.",
        "en": "The file name must contain between 1 and 200 characters.",
        "public_translation": true
    },
    {
        "id": 20035,
        "key": "message_20035",
        "ru": "Выберите файл трека и отправьте его через форму загрузки.",
        "en": "Select a track file and submit it using the upload form.",
        "public_translation": true
    },
    {
        "id": 20036,
        "key": "message_20036",
        "ru": "Выберите файл трека для загрузки.",
        "en": "Select a track file to upload.",
        "public_translation": true
    },
    {
        "id": 20037,
        "key": "message_20037",
        "ru": "Для каждого файла трека укажите тип, название, пункт путешествия и даты.",
        "en": "Specify the type, name, trip item and dates for each track file.",
        "public_translation": true
    },
    {
        "id": 20038,
        "key": "message_20038",
        "ru": "Трек №{p0}: укажите дату в формате ГГГГ-ММ-ДД.",
        "en": "Track #{p0}: enter the date in YYYY-MM-DD format.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20039,
        "key": "message_20039",
        "ru": "Трек №{p0}: выберите тип трека.",
        "en": "Track #{p0}: select a track type.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20040,
        "key": "message_20040",
        "ru": "Трек №{p0}: выберите пункт путешествия.",
        "en": "Track #{p0}: select a trip item.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20041,
        "key": "message_20041",
        "ru": "Трек №{p0}: выбранный пункт не относится к этому путешествию.",
        "en": "Track #{p0}: the selected item does not belong to this trip.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20042,
        "key": "message_20042",
        "ru": "Трек №{p0}: дата окончания не может быть раньше даты начала.",
        "en": "Track #{p0}: the end date cannot be earlier than the start date.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20043,
        "key": "message_20043",
        "ru": "Введите не более {p0} символов.",
        "en": "Ensure this field has no more than {p0} characters.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20044,
        "key": "message_20044",
        "ru": "Введите не менее {p0} символов.",
        "en": "Ensure this field has at least {p0} characters.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20045,
        "key": "message_20045",
        "ru": "Введите число не меньше {p0}.",
        "en": "Ensure this value is greater than or equal to {p0}.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20046,
        "key": "message_20046",
        "ru": "Введите число не больше {p0}.",
        "en": "Ensure this value is less than or equal to {p0}.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20047,
        "key": "message_20047",
        "ru": "Выбранная запись №{p0} не найдена. Повторите выбор.",
        "en": "Invalid pk \"{p0}\" - object does not exist.",
        "public_translation": true,
        "template": true
    },
    {
        "id": 20048,
        "key": "route_service_unavailable",
        "ru": "Сервис построения маршрутов временно недоступен. Попробуйте позже.",
        "en": "The route planning service is temporarily unavailable. Try again later."
    },
    {
        "id": 20049,
        "key": "message_20049",
        "ru": "Для построения трека укажите хотя бы две точки.",
        "en": "Select at least two points to build a track.",
        "aliases": [
            "Для построения трека нужно передать две точки."
        ],
        "public_translation": true
    },
    {
        "id": 20050,
        "key": "message_20050",
        "ru": "Точки должны относиться к одному пункту путешествия.",
        "en": "Points must belong to the same trip item.",
        "aliases": [
            "Точки должны принадлежать одному item."
        ],
        "public_translation": true
    },
    {
        "id": 20051,
        "key": "message_20051",
        "ru": "Точки не соответствуют выбранному пункту путешествия.",
        "en": "Points do not match the selected trip item.",
        "aliases": [
            "Точки не соответствуют выбранному item."
        ],
        "public_translation": true
    },
    {
        "id": 20052,
        "key": "message_20052",
        "ru": "Слишком много запросов на построение маршрута. Подождите немного и попробуйте снова.",
        "en": "Too many route planning requests. Wait a moment and try again.",
        "aliases": [
            "Mapbox временно ограничил запросы. Попробуйте позже."
        ],
        "public_translation": true
    },
    {
        "id": 20053,
        "key": "message_20053",
        "ru": "Не удалось получить маршрут. Повторите выбор точек на карте.",
        "en": "Unable to obtain a route. Select the points on the map again.",
        "aliases": [
            "Mapbox вернул некорректную геометрию маршрута."
        ],
        "public_translation": true
    },
    {
        "id": 20054,
        "key": "message_20054",
        "ru": "Не удалось получить маршрут из-за сетевой ошибки. Попробуйте ещё раз.",
        "en": "Unable to obtain a route due to a network error. Try again.",
        "aliases": [
            "Сетевая ошибка при обращении к Mapbox."
        ],
        "public_translation": true
    },
    {
        "id": 20055,
        "key": "message_20055",
        "ru": "Маршрут между выбранными точками не найден. Попробуйте другой способ передвижения.",
        "en": "No route was found between the selected points. Try another transport mode.",
        "aliases": [
            "Mapbox не нашел маршрут между указанными точками."
        ],
        "public_translation": true
    },
    {
        "id": 20056,
        "key": "message_20056",
        "ru": "Не удалось определить тип трека. Выберите способ передвижения ещё раз.",
        "en": "Unable to identify the track type. Select the transport mode again.",
        "aliases": [
            "GPX type was not resolved for route profile."
        ],
        "public_translation": true
    },
    {
        "id": 20057,
        "key": "message_20057",
        "ru": "Укажите не более {p0} знаков после запятой.",
        "en": "Ensure that there are no more than {p0} decimal places.",
        "template": true,
        "public_translation": true
    },
    {
        "id": 20058,
        "key": "message_20058",
        "ru": "Число должно содержать не более {p0} цифр.",
        "en": "Ensure that there are no more than {p0} digits in total.",
        "template": true,
        "public_translation": true
    },
    {
        "id": 20059,
        "key": "message_20059",
        "ru": "Целая часть числа должна содержать не более {p0} цифр.",
        "en": "Ensure that there are no more than {p0} digits before the decimal point.",
        "template": true,
        "public_translation": true
    },
    {
        "id": 20060,
        "key": "message_20060",
        "ru": "Некорректная дата установки.",
        "en": "Invalid installation date.",
        "public_translation": true
    },
    {
        "id": 20061,
        "key": "message_20061",
        "ru": "Выберите период: 7 дней, 30 дней или всё время.",
        "en": "Choose a period: 7 days, 30 days, or all time.",
        "public_translation": true
    },
    {
        "id": 20062,
        "key": "message_20062",
        "ru": "Некорректный фильтр платформы.",
        "en": "Invalid platform filter.",
        "public_translation": true
    },
    {
        "id": 20063,
        "key": "message_20063",
        "ru": "В GPX нет трека. Экспортируйте маршрут как GPX-трек.",
        "en": "The GPX contains no track. Export the route as a GPX track.",
        "public_translation": true
    },
    {
        "id": 20064,
        "key": "message_20064",
        "ru": "В GPX есть некорректные координаты.",
        "en": "The GPX contains invalid coordinates.",
        "public_translation": true
    },
    {
        "id": 20065,
        "key": "message_20065",
        "ru": "Не удалось прочитать GPX. Проверьте файл и экспортируйте его заново.",
        "en": "Unable to read the GPX. Check the file and export it again.",
        "public_translation": true
    },
    {
        "id": 20066,
        "key": "message_20066",
        "ru": "Для импорта нужен GPX версии 1.1.",
        "en": "Import requires GPX version 1.1.",
        "public_translation": true
    }
];
